export default Object.freeze({
  COUNTRY_CODES: [
    { code: "SG", name: "SINGAPORE" },
    { code: "AF", name: "AFGHANISTAN" },
    { code: "AL", name: "ALBANIA" },
    { code: "DZ", name: "ALGERIA" },
    { code: "AS", name: "AMERICAN SAMOA" },
    { code: "AD", name: "ANDORRA" },
    { code: "AO", name: "ANGOLA" },
    { code: "AI", name: "ANGUILLA" },
    { code: "AG", name: "ANTIGUA" },
    { code: "AR", name: "ARGENTINA" },
    { code: "AM", name: "ARMENIA" },
    { code: "AB", name: "ARUBA" },
    { code: "AU", name: "AUSTRALIA" },
    { code: "AT", name: "AUSTRIA" },
    { code: "AZ", name: "AZERBAIJAN" },
    { code: "BS", name: "BAHAMAS" },
    { code: "BH", name: "BAHRAIN" },
    { code: "BD", name: "BANGLADESH" },
    { code: "BB", name: "BARBADOS" },
    { code: "BL", name: "BELARUS" },
    { code: "BE", name: "BELGIUM" },
    { code: "BZ", name: "BELIZE" },
    { code: "BJ", name: "BENIN" },
    { code: "BM", name: "BERMUDA" },
    { code: "BT", name: "BHUTAN" },
    { code: "BO", name: "BOLIVIA" },
    { code: "BA", name: "BOSNIA-HERZEGOVINA" },
    { code: "BW", name: "BOTSWANA" },
    { code: "BR", name: "BRAZIL" },
    { code: "BQ", name: "BRITISH ANTARCTIC TERRITORY" },
    { code: "IO", name: "BRITISH INDIAN OCEAN TERRITORY" },
    { code: "VG", name: "BRITISH VIRGIN ISLANDS" },
    { code: "BN", name: "BRUNEI" },
    { code: "BG", name: "BULGARIA" },
    { code: "BF", name: "BURKINA FASO" },
    { code: "BI", name: "BURUNDI" },
    { code: "KA", name: "CAMBODIA" },
    { code: "CM", name: "CAMEROON" },
    { code: "CA", name: "CANADA" },
    { code: "CT", name: "CANTON & ENDERBURY ISLANDS" },
    { code: "CV", name: "CAPE VERDE" },
    { code: "KY", name: "CAYMAN ISLANDS" },
    { code: "CF", name: "CENTRAL AFRICAN REPUBLIC" },
    { code: "TD", name: "CHAD" },
    { code: "CD", name: "CHANNEL ISLANDS" },
    { code: "CL", name: "CHILE" },
    { code: "CN", name: "CHINA" },
    { code: "CX", name: "CHRISTMAS ISLAND" },
    { code: "CC", name: "COCOS KEELING ISLAND" },
    { code: "CO", name: "COLOMBIA" },
    { code: "KM", name: "COMOROS" },
    { code: "CG", name: "CONGO" },
    { code: "CK", name: "COOK ISLANDS" },
    { code: "CR", name: "COSTA RICA" },
    { code: "CB", name: "CROATIA" },
    { code: "CU", name: "CUBA" },
    { code: "CY", name: "CYPRUS" },
    { code: "CZ", name: "CZECH REPUBLIC" },
    { code: "KP", name: "D.P.R. KOREA" },
    { code: "DK", name: "DENMARK" },
    { code: "DJ", name: "DJIBOUTI" },
    { code: "DM", name: "DOMINICA" },
    { code: "DO", name: "DOMINICAN REPUBLIC" },
    { code: "TP", name: "EAST TIMOR" },
    { code: "EC", name: "ECUADOR" },
    { code: "EG", name: "EGYPT" },
    { code: "SV", name: "EL SALVADOR" },
    { code: "GQ", name: "EQUATORIAL GUINEA" },
    { code: "ER", name: "ERITREA" },
    { code: "EN", name: "ESTONIA" },
    { code: "ET", name: "ETHIOPIA" },
    { code: "FO", name: "FAEROE ISLANDS" },
    { code: "FK", name: "FALKLAND ISLANDS" },
    { code: "FJ", name: "FIJI" },
    { code: "FI", name: "FINLAND" },
    { code: "FR", name: "FRANCE" },
    { code: "GF", name: "FRENCH GUIANA" },
    { code: "PF", name: "FRENCH POLYNESIA" },
    { code: "FQ", name: "FRENCH SOUTHERN & ANTARCTIC TERRITORIES" },
    { code: "GA", name: "GABON" },
    { code: "GM", name: "GAMBIA" },
    { code: "GZ", name: "GAZA" },
    { code: "GO", name: "GEORGIA" },
    { code: "DG", name: "GERMANY" },
    { code: "GH", name: "GHANA" },
    { code: "GI", name: "GIBRALTAR" },
    { code: "GR", name: "GREECE" },
    { code: "GL", name: "GREENLAND" },
    { code: "GD", name: "GRENADA" },
    { code: "GP", name: "GUADELOUPE" },
    { code: "GU", name: "GUAM" },
    { code: "GT", name: "GUATEMALA" },
    { code: "GK", name: "GUERNSEY" },
    { code: "GN", name: "GUINEA" },
    { code: "GW", name: "GUINEA-BISSAU" },
    { code: "GY", name: "GUYANA" },
    { code: "HT", name: "HAITI" },
    { code: "HM", name: "HEARD ISLAND & MCDONALD ISLANDS" },
    { code: "HN", name: "HONDURAS" },
    { code: "HK", name: "HONG KONG" },
    { code: "HS", name: "HONG KONG SAR" },
    { code: "HU", name: "HUNGARY" },
    { code: "IS", name: "ICELAND" },
    { code: "IN", name: "INDIA" },
    { code: "ID", name: "INDONESIA" },
    { code: "IR", name: "IRAN" },
    { code: "IQ", name: "IRAQ" },
    { code: "IE", name: "IRELAND" },
    { code: "MM", name: "ISLE OF MAN" },
    { code: "IL", name: "ISRAEL" },
    { code: "IT", name: "ITALY" },
    { code: "CI", name: "IVORY COAST" },
    { code: "JM", name: "JAMAICA" },
    { code: "JP", name: "JAPAN" },
    { code: "JT", name: "JOHNSTON ISLAND" },
    { code: "JO", name: "JORDAN" },
    { code: "KZ", name: "KAZAKHSTAN" },
    { code: "KE", name: "KENYA" },
    { code: "KG", name: "KIRGHIZIA" },
    { code: "KI", name: "KIRIBATI" },
    { code: "KR", name: "KOREA, SOUTH" },
    { code: "KV", name: "KOSOVO" },
    { code: "KW", name: "KUWAIT" },
    { code: "KS", name: "KYRGYZSTAN" },
    { code: "LA", name: "LAOS" },
    { code: "LV", name: "LATVIA" },
    { code: "LB", name: "LEBANON" },
    { code: "LS", name: "LESOTHO" },
    { code: "LR", name: "LIBERIA" },
    { code: "LY", name: "LIBYA" },
    { code: "LI", name: "LIECHTENSTEIN" },
    { code: "LH", name: "LITHUANIA" },
    { code: "LU", name: "LUXEMBOURG" },
    { code: "MO", name: "MACAO" },
    { code: "MF", name: "MACAU SAR" },
    { code: "MB", name: "MACEDONIA" },
    { code: "MG", name: "MADAGASCAR" },
    { code: "MW", name: "MALAWI" },
    { code: "MY", name: "MALAYSIA" },
    { code: "MV", name: "MALDIVES" },
    { code: "ML", name: "MALI" },
    { code: "MT", name: "MALTA" },
    { code: "MH", name: "MARSHALL ISLANDS" },
    { code: "MQ", name: "MARTINIQUE" },
    { code: "MR", name: "MAURITANIA" },
    { code: "MU", name: "MAURITIUS" },
    { code: "ME", name: "MAYOTTE" },
    { code: "MX", name: "MEXICO" },
    { code: "MI", name: "MIDWAY ISLANDS" },
    { code: "MD", name: "MOLDOVA" },
    { code: "MC", name: "MONACO" },
    { code: "MN", name: "MONGOLIA" },
    { code: "MJ", name: "MONTENEGRO" },
    { code: "MS", name: "MONTSERRAT" },
    { code: "MA", name: "MOROCCO" },
    { code: "MZ", name: "MOZAMBIQUE" },
    { code: "BU", name: "MYANMAR" },
    { code: "NA", name: "NAMIBIA" },
    { code: "NR", name: "NAURU" },
    { code: "NP", name: "NEPAL" },
    { code: "NL", name: "NETHERLANDS" },
    { code: "AN", name: "NETHERLANDS ANTILLES" },
    { code: "NC", name: "NEW CALEDONIA" },
    { code: "NZ", name: "NEW ZEALAND" },
    { code: "NI", name: "NICARAGUA" },
    { code: "NE", name: "NIGER" },
    { code: "NG", name: "NIGERIA" },
    { code: "NU", name: "NIUE ISLAND" },
    { code: "NF", name: "NORFOLK ISLAND" },
    { code: "NO", name: "NORWAY" },
    { code: "OM", name: "OMAN" },
    { code: "XX", name: "OTHERS" },
    { code: "PC", name: "PACIFIC ISLAND TRUST TERRITORY" },
    { code: "PK", name: "PAKISTAN" },
    { code: "PW", name: "PALAU" },
    { code: "PB", name: "PALESTINE" },
    { code: "PA", name: "PANAMA" },
    { code: "PZ", name: "PANAMA CANAL ZONE" },
    { code: "PG", name: "PAPUA NEW GUINEA" },
    { code: "PY", name: "PARAGUAY" },
    { code: "PE", name: "PERU" },
    { code: "PH", name: "PHILIPPINES" },
    { code: "PN", name: "PITCAIRN ISLAND" },
    { code: "PL", name: "POLAND" },
    { code: "PT", name: "PORTUGAL" },
    { code: "PR", name: "PUERTO RICO" },
    { code: "QA", name: "QATAR" },
    { code: "RE", name: "REUNION" },
    { code: "RO", name: "ROMANIA" },
    { code: "RF", name: "RUSSIA" },
    { code: "RW", name: "RWANDA" },
    { code: "WM", name: "SAMOA" },
    { code: "SM", name: "SAN MARINO" },
    { code: "ST", name: "SAO TOME & PRINCIPE" },
    { code: "SA", name: "SAUDI ARABIA" },
    { code: "SN", name: "SENEGAL" },
    { code: "RS", name: "SERBIA" },
    { code: "SF", name: "SERBIA/MONTENEGRO" },
    { code: "SC", name: "SEYCHELLES" },
    { code: "SL", name: "SIERRA LEONE" },
    { code: "SK", name: "SLOVAK REPUBLIC" },
    { code: "SI", name: "SLOVENIA" },
    { code: "SB", name: "SOLOMON ISLANDS" },
    { code: "SO", name: "SOMALIA" },
    { code: "ZA", name: "SOUTH AFRICA" },
    { code: "ES", name: "SPAIN" },
    { code: "LK", name: "SRI LANKA" },
    { code: "SH", name: "ST. HELENA" },
    { code: "KN", name: "ST. KITTS-NEVIS" },
    { code: "LC", name: "ST. LUCIA" },
    { code: "PM", name: "ST. PIERRE & MIQUELON" },
    { code: "VC", name: "ST. VINCENT" },
    { code: "SD", name: "SUDAN" },
    { code: "SR", name: "SURINAME" },
    { code: "SZ", name: "SWAZILAND" },
    { code: "SE", name: "SWEDEN" },
    { code: "CH", name: "SWITZERLAND" },
    { code: "SY", name: "SYRIA" },
    { code: "TW", name: "TAIWAN" },
    { code: "TI", name: "TAJIKISTAN" },
    { code: "TZ", name: "TANZANIA" },
    { code: "TH", name: "THAILAND" },
    { code: "TE", name: "TIMOR" },
    { code: "TG", name: "TOGO" },
    { code: "TK", name: "TOKELAU ISLANDS" },
    { code: "TO", name: "TONGA" },
    { code: "TT", name: "TRINIDAD & TOBAGO" },
    { code: "TN", name: "TUNISIA" },
    { code: "TR", name: "TURKEY" },
    { code: "TM", name: "TURKMENISTAN" },
    { code: "TC", name: "TURKS & CAICOS ISLANDS" },
    { code: "TV", name: "TUVALU" },
    { code: "UG", name: "UGANDA" },
    { code: "UR", name: "UKRAINE" },
    { code: "AE", name: "UNITED ARAB EMIRATES" },
    { code: "GB", name: "UNITED KINGDOM" },
    { code: "US", name: "UNITED STATES" },
    { code: "UN", name: "UNKNOWN" },
    { code: "HV", name: "UPPER VOLTA" },
    { code: "UY", name: "URUGUAY" },
    { code: "VI", name: "US VIRGIN ISLANDS" },
    { code: "UZ", name: "UZBEKISTAN" },
    { code: "VU", name: "VANUATU" },
    { code: "VA", name: "VATICAN CITY STATE" },
    { code: "VE", name: "VENEZUELA" },
    { code: "VN", name: "VIETNAM" },
    { code: "WK", name: "WAKE ISLAND" },
    { code: "WF", name: "WALLIS AND FUTUNA" },
    { code: "EH", name: "WESTERN SAHARA" },
    { code: "YM", name: "YEMEN" },
    { code: "YU", name: "YUGOSLAVIA" },
    { code: "ZR", name: "ZAIRE" },
    { code: "ZM", name: "ZAMBIA" },
    { code: "ZW", name: "ZIMBABWE" },
  ],
  COUNTRY_OF_BIRTH: [
    "Afghanistan",
    "Albania",
    "Algeria",
    "American Samoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia Herzegovina",
    "Botswana",
    "Brazil",
    "British Antarctic Territory",
    "British Indian Ocean Territory",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Canton & Enderbury Islands",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Channel Islands",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos Keeling Island",
    "Colombia",
    "Comoros",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Czechoslovakia",
    "D.p.r. Korea",
    "Democratic Republic Of Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Faeroe Islands",
    "Falkland Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "French Southern & Antarctic Territories",
    "Gabon",
    "Gambia",
    "Gaza",
    "Georgia",
    "Germany",
    "Germany, East",
    "Germany, West",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea Bissau",
    "Guyana",
    "Haiti",
    "Heard Island & Mcdonald Islands",
    "Honduras",
    "Hong Kong",
    "Hong Kong Sar",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle Of Man",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jerusalem",
    "Johnston Island",
    "Jordan",
    "Kampuchea",
    "Kazakhstan",
    "Kenya",
    "Kirghizia",
    "Kiribati",
    "Korea, South",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Macao Sar",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Midway Islands",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "Netherlands Antilles",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue Island",
    "Norfolk Island",
    "North Macedonia",
    "Norway",
    "Oman",
    "Others",
    "Pacific Island Trust Territory",
    "Pakistan",
    "Palau",
    "Palestine",
    "Panama",
    "Panama Canal Zone",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Pitcairn Island",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Reunion",
    "Romania",
    "Russia",
    "Rwanda",
    "Samoa",
    "San Marino",
    "Sao Tome & Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Serbia/montenegro",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovak Republic",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Soviet Union",
    "Spain",
    "Sri Lanka",
    "St. Helena",
    "St. Kitts Nevis",
    "St. Lucia",
    "St. Pierre & Miquelon",
    "St. Vincent",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Tadzhikistan",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor",
    "Togo",
    "Tokelau Islands",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkmenistan",
    "Turks & Caicos Islands",
    "Tuvalu",
    "Türki̇ye",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Unknown",
    "Upper Volta",
    "Uruguay",
    "Us Virgin Islands",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City State",
    "Venezuela",
    "Vietnam",
    "Wake Island",
    "Wallis And Futuna",
    "Western Sahara",
    "Western Samoa",
    "Yemen",
    "Yemen Arab Rep",
    "Yemen, South",
    "Yugoslavia",
    "Zambia",
    "Zimbabwe",
  ],
  REFUND_REASONS: [
    "Product quality",
    "Product expired",
    "Damaged packing",
    "Change of mind",
    "Side effect",
    "Others",
  ],
  TITLE_OF_PERSON: [
    {
      label: "-",
      value: "-",
    },
    {
      label: "general.dr",
      value: "DR",
    },
    {
      label: "general.miss",
      value: "MISS",
    },
    {
      label: "patientTitles.bo",
      value: "B/O",
    },
    {
      label: "general.mr",
      value: "MR",
    },
    {
      label: "general.ms",
      value: "MS",
    },
    {
      label: "general.mdm",
      value: "MDM",
    },
    {
      label: "patientTitles.so",
      value: "S/O",
    },
    {
      label: "patientTitles.do",
      value: "D/O",
    },
    {
      label: "general.mrs",
      value: "MRS",
    },
    {
      label: "patientTitles.ho",
      value: "H/O",
    },
    {
      label: "patientTitles.master",
      value: "MASTER",
    },
  ],
  LOCAL_TITLES_BGRIMM: [
    {
      value: "-",
      label: "-",
    },
    {
      value: "นาย",
      label: "นาย",
    },
    {
      value: "นาง",
      label: "นาง",
    },
    {
      value: "นางสาว",
      label: "นางสาว",
    },
    {
      value: "เด็กหญิง",
      label: "เด็กหญิง",
    },
    {
      value: "เด็กชาย",
      label: "เด็กชาย",
    },
    {
      value: "จอมพล",
      label: "จอมพล",
    },
    {
      value: "พลเอก",
      label: "พลเอก",
    },
    {
      value: "พลโท",
      label: "พลโท",
    },
    {
      value: "พลตรี",
      label: "พลตรี",
    },
    {
      value: "พันเอก",
      label: "พันเอก",
    },
    {
      value: "พันโท",
      label: "พันโท",
    },
    {
      value: "พันตรี",
      label: "พันตรี",
    },
    {
      value: "ร้อยเอก",
      label: "ร้อยเอก",
    },
    {
      value: "ร้อยโท",
      label: "ร้อยโท",
    },
    {
      value: "ร้อยตรี",
      label: "ร้อยตรี",
    },
    {
      value: "จ่าสิบเอก",
      label: "จ่าสิบเอก",
    },
    {
      value: "จ่าสิบโท",
      label: "จ่าสิบโท",
    },
    {
      value: "จ่าสิบตรี",
      label: "จ่าสิบตรี",
    },
    {
      value: "สิบเอก",
      label: "สิบเอก",
    },
    {
      value: "สิบโท",
      label: "สิบโท",
    },
    {
      value: "สิบตรี",
      label: "สิบตรี",
    },
    {
      value: "พลทหาร",
      label: "พลทหาร",
    },
    {
      value: "นักเรียนนายร้อย",
      label: "นักเรียนนายร้อย",
    },
    {
      value: "นักเรียนนายสิบ",
      label: "นักเรียนนายสิบ",
    },
    {
      value: "ว่าที่พันตรี",
      label: "ว่าที่พันตรี",
    },
    {
      value: "ว่าที่ร้อยเอก",
      label: "ว่าที่ร้อยเอก",
    },
    {
      value: "ว่าที่ร้อยโท",
      label: "ว่าที่ร้อยโท",
    },
    {
      value: "ว่าที่ร้อยตรี",
      label: "ว่าที่ร้อยตรี",
    },
    {
      value: "นักศึกษาวิชาทหาร",
      label: "นักศึกษาวิชาทหาร",
    },
    {
      value: "จอมพลเรือ",
      label: "จอมพลเรือ",
    },
    {
      value: "พลเรือเอก",
      label: "พลเรือเอก",
    },
    {
      value: "พลเรือโท",
      label: "พลเรือโท",
    },
    {
      value: "พลเรือตรี",
      label: "พลเรือตรี",
    },
    {
      value: "นาวาเอก",
      label: "นาวาเอก",
    },
    {
      value: "นาวาโท",
      label: "นาวาโท",
    },
    {
      value: "นาวาตรี",
      label: "นาวาตรี",
    },
    {
      value: "เรือเอก",
      label: "เรือเอก",
    },
    {
      value: "เรือโท",
      label: "เรือโท",
    },
    {
      value: "เรือตรี",
      label: "เรือตรี",
    },
    {
      value: "พันจ่าเอก",
      label: "พันจ่าเอก",
    },
    {
      value: "พันจ่าโท",
      label: "พันจ่าโท",
    },
    {
      value: "พันจ่าตรี",
      label: "พันจ่าตรี",
    },
    {
      value: "จ่าเอก",
      label: "จ่าเอก",
    },
    {
      value: "จ่าโท",
      label: "จ่าโท",
    },
    {
      value: "จ่าตรี",
      label: "จ่าตรี",
    },
    {
      value: "พลทหาร",
      label: "พลทหาร",
    },
    {
      value: "นักเรียนทหารเรือ",
      label: "นักเรียนทหารเรือ",
    },
    {
      value: "นักเรียนจ่าทหารเรือ",
      label: "นักเรียนจ่าทหารเรือ",
    },
    {
      value: "จอมพลอากาศ",
      label: "จอมพลอากาศ",
    },
    {
      value: "พลอากาศเอก",
      label: "พลอากาศเอก",
    },
    {
      value: "พลอากาศโท",
      label: "พลอากาศโท",
    },
    {
      value: "พลอากาศตรี",
      label: "พลอากาศตรี",
    },
    {
      value: "นาวาอากาศเอก",
      label: "นาวาอากาศเอก",
    },
    {
      value: "นาวาอากาศโท",
      label: "นาวาอากาศโท",
    },
    {
      value: "นาวาอากาศตรี",
      label: "นาวาอากาศตรี",
    },
    {
      value: "เรืออากาศเอก",
      label: "เรืออากาศเอก",
    },
    {
      value: "เรืออากาศโท",
      label: "เรืออากาศโท",
    },
    {
      value: "เรืออากาศตรี",
      label: "เรืออากาศตรี",
    },
    {
      value: "พันจ่าอากาศเอก",
      label: "พันจ่าอากาศเอก",
    },
    {
      value: "พันจ่าอากาศโท",
      label: "พันจ่าอากาศโท",
    },
    {
      value: "พันจ่าอากาศตรี",
      label: "พันจ่าอากาศตรี",
    },
    {
      value: "จ่าอากาศเอก",
      label: "จ่าอากาศเอก",
    },
    {
      value: "จ่าอากาศโท",
      label: "จ่าอากาศโท",
    },
    {
      value: "จ่าอากาศตรี",
      label: "จ่าอากาศตรี",
    },
    {
      value: "พลทหาร",
      label: "พลทหาร",
    },
    {
      value: "นักเรีนนายเรืออากาศ",
      label: "นักเรีนนายเรืออากาศ",
    },
    {
      value: "นักเรียนจ่าอากาศ",
      label: "นักเรียนจ่าอากาศ",
    },
    {
      value: "พลตำรวจเอก",
      label: "พลตำรวจเอก",
    },
    {
      value: "พลตำรวจโท",
      label: "พลตำรวจโท",
    },
    {
      value: "พลตำรวจตรี",
      label: "พลตำรวจตรี",
    },
    {
      value: "พันตำรวจเอก",
      label: "พันตำรวจเอก",
    },
    {
      value: "พันตำรวจโท",
      label: "พันตำรวจโท",
    },
    {
      value: "พันตำรวจตรี",
      label: "พันตำรวจตรี",
    },
    {
      value: "ร้อยตำรวจเอก",
      label: "ร้อยตำรวจเอก",
    },
    {
      value: "ร้อยตำรวจโท",
      label: "ร้อยตำรวจโท",
    },
    {
      value: "ร้อยตำรวจตรี",
      label: "ร้อยตำรวจตรี",
    },
    {
      value: "ดาบตำรวจ",
      label: "ดาบตำรวจ",
    },
    {
      value: "จ่าสิบตำรวจ",
      label: "จ่าสิบตำรวจ",
    },
    {
      value: "สิบตำรวจเอก",
      label: "สิบตำรวจเอก",
    },
    {
      value: "สิบตำรวจโท",
      label: "สิบตำรวจโท",
    },
    {
      value: "สิบตำรวจตรี",
      label: "สิบตำรวจตรี",
    },
    {
      value: "สามเณร",
      label: "สามเณร",
    },
    {
      value: "พระอธิการ",
      label: "พระอธิการ",
    },
    {
      value: "พระปลัด",
      label: "พระปลัด",
    },
    {
      value: "พระใบฎีกา",
      label: "พระใบฎีกา",
    },
    {
      value: "พระครูสมุห์",
      label: "พระครูสมุห์",
    },
    {
      value: "พระมหา",
      label: "พระมหา",
    },
    {
      value: "พระครูวินัยธร",
      label: "พระครูวินัยธร",
    },
    {
      value: "เจ้าอธิการ",
      label: "เจ้าอธิการ",
    },
    {
      value: "พระสมุห์",
      label: "พระสมุห์",
    },
    {
      value: "พระครูปลัด",
      label: "พระครูปลัด",
    },
    {
      value: "พระครูใบฎีกา",
      label: "พระครูใบฎีกา",
    },
    {
      value: "พระครูธรรมธร",
      label: "พระครูธรรมธร",
    },
    {
      value: "พระสงฆ์",
      label: "พระสงฆ์",
    },
    {
      value: "บาทหลวง",
      label: "บาทหลวง",
    },
    {
      value: "หม่อมหลวง",
      label: "หม่อมหลวง",
    },
    {
      value: "หม่อมราชวงศ์",
      label: "หม่อมราชวงศ์",
    },
    {
      value: "หม่อมเจ้า",
      label: "หม่อมเจ้า",
    },
    {
      value: "ศาสตราจารย์เกียรติคุณ (กิตติคุณ)",
      label: "ศาสตราจารย์เกียรติคุณ (กิตติคุณ)",
    },
    {
      value: "ศาสตราจารย์",
      label: "ศาสตราจารย์",
    },
    {
      value: "ผู้ช่วยศาสตราจารย์",
      label: "ผู้ช่วยศาสตราจารย์",
    },
    {
      value: "รองศาสตราจารย์",
      label: "รองศาสตราจารย์",
    },
  ],
  GENDER: {
    Male: "Male",
    Female: "Female",
    Unknown: "Unknown",
  },
  GENDERS: [
    { label: "general.male", value: "M" },
    { label: "general.female", value: "F" },
    { label: "general.unknown", value: "U" },
  ],
  RELATIONSHIP: [
    { value: "Wife", text: "Wife" },
    { value: "Husband", text: "Husband" },
    { value: "Mother", text: "Mother" },
    { value: "Father", text: "Father" },
    { value: "Daughter", text: "Daughter" },
    { value: "Son", text: "Son" },
    { value: "Sister", text: "Sister" },
    { value: "Brother", text: "Brother" },
  ],
  NRIC_TYPES: [
    {
      value: "SB",
      label: "Singapore Blue Identification Card",
    },
    {
      value: "SP",
      label: "Singapore Pink Identification Card",
    },
    {
      value: "SO",
      label: "Fin/Work Permit/SAF 11B",
    },
    {
      value: "FD",
      label: "Foreign Document",
    },
    {
      value: "CK",
      label: "Child Key",
    },
    {
      value: "DL",
      label: "Driving License",
    },
    {
      value: "DR",
      label: "Death Registration No",
    },
    {
      value: "FI",
      label: "Foreign Identity Document",
    },
    {
      value: "FP",
      label: "Foreign Travel Document",
    },
    {
      value: "MB",
      label: "Malaysian Blue Identification Card",
    },
    {
      value: "MC",
      label: "Malaysian Citizenship Certificate",
    },
    {
      value: "MH",
      label: "Malaysian Birth Certificate",
    },
    {
      value: "MP",
      label: "Malaysian Passport",
    },
    {
      value: "MR",
      label: "Malaysian Red Identification Card",
    },
    {
      value: "NA",
      label: "Not Applicable/Nil",
    },
    {
      value: "NB",
      label: "New Malaysian Blue Identification Card",
    },
    {
      value: "NR",
      label: "New Malaysian Red Identification Card",
    },
    {
      value: "OB",
      label: "Non-Malaysian Birth Certificate",
    },
    {
      value: "OT",
      label: "Others",
    },

    {
      value: "SC",
      label: "Singapore Citizenship Certificate",
    },
    {
      value: "SE",
      label: "Singapore Exit Permit",
    },
    {
      value: "SH",
      label: "Singapore Birth Certificate",
    },
    {
      value: "SI",
      label: "Singapore International Passport",
    },
    {
      value: "SM",
      label: "Seaman Book/Document",
    },

    {
      value: "SS",
      label: "Singapore Special Pass",
    },
    {
      value: "TN",
      label: "Truncated Document Number",
    },
  ],
  INVOICE_CATEGORY: [
    { label: "-", value: "-" },
    { label: "general.consult", value: "Consultation" },
    { label: "general.prescriptionFormTitle", value: "Prescription" },
    { label: "nursingVentilation.therapy", value: "Therapy" },
    { label: "general.invTypeProduct", value: "Product" },
    { label: "general.invTypePackage", value: "Package" },
    { label: "general.invTypeLaboratory", value: "Laboratory" },
    { label: "general.invTypeExpendables", value: "Expendables" },
    { label: "general.invTypeWyn", value: "Wyn" },
  ],
  MARITAL_STATUS: [
    { label: "general.single", value: "Single" },
    { label: "general.married", value: "Married" },
    { label: "general.widowed", value: "Widowed" },
    { label: "general.divorced", value: "Divorced" },
  ],
  VITALS_MAP: {
    height: "Height",
    weight: "Weight",
    bmi: "BMI",
    waist: "Waist Circumference",
    pulse: "Pulse",
    systolic: "Systolic",
    diastolic: "Diastolic",
  },
  PATIENT_TYPES: [
    { value: "corporate", label: "Corporate" },
    { value: "private", label: "Private" },
    { value: "staff", label: "Staff" },
  ],
  RACE: [
    "Achehnese",
    "Afghan",
    "African",
    "Albanian",
    "Ambonese",
    "American",
    "Amerindian",
    "Anglo Burmese",
    "Anglo Chinese",
    "Anglo Filipino",
    "Anglo Indian",
    "Anglo Saxon",
    "Anglo Thai",
    "Annamite",
    "Arab",
    "Armenian",
    "Aryan",
    "Assami",
    "Australian",
    "Austrian",
    "Azeri",
    "Bajau",
    "Balinese",
    "Bamar",
    "Bangala",
    "Bangladeshi",
    "Banjarese",
    "Banten",
    "Basque",
    "Batak",
    "Belgian",
    "Bengali",
    "Betawi",
    "Bhutanese",
    "Bidayuh",
    "Bisaya",
    "Bosniak",
    "Boyanese",
    "Brahmin",
    "Brazilian",
    "British",
    "Bugis",
    "Bulgarian",
    "Burgher",
    "Burmese",
    "Butonese",
    "Cambodian",
    "Canadian",
    "Cape Coloured",
    "Caribbean",
    "Caucasian",
    "Ceylon Moor",
    "Ceylonese",
    "Chamorro",
    "Chinese",
    "Cocos",
    "Cornish",
    "Creole",
    "Croat",
    "Czech",
    "Czechoslovak",
    "Dane",
    "Dayak",
    "Dusun",
    "Dutch",
    "Dutch Burgher",
    "Egyptian",
    "English",
    "Ethiopian",
    "Eurasian",
    "European",
    "Fijian",
    "Filipino",
    "Finn",
    "Flemish",
    "French",
    "German",
    "Ghanaian",
    "Goan",
    "Goanese",
    "Greek",
    "Gujarati",
    "Gurkha",
    "Haitian",
    "Hawaiian",
    "Hindustani",
    "Hispanic",
    "Hollander",
    "Hungarian",
    "Iban",
    "Icelander",
    "Indian",
    "Indonesian",
    "Inuit",
    "Iranian",
    "Iraqi",
    "Irish",
    "Isoko",
    "Israeli",
    "Italian",
    "Jakun",
    "Jamaican",
    "Japanese",
    "Javanese",
    "Jew",
    "Jordanian",
    "Kachin",
    "Kadazan",
    "Kampuchean",
    "Karen",
    "Kayah",
    "Kayan",
    "Kayin",
    "Kazakh",
    "Kelabit",
    "Kenyah",
    "Kenyan",
    "Khasi",
    "Khmer",
    "Kinh",
    "Korean",
    "Kyrgyz",
    "Lao",
    "Latin",
    "Latvian",
    "Lebanese",
    "Libyan",
    "Lisu",
    "Lithuanian",
    "Luxembourger",
    "Madurese",
    "Magyars",
    "Mahratta",
    "Makasarese",
    "Malabari",
    "Malagasy",
    "Malay",
    "Malayalee",
    "Maldivian",
    "Maltese",
    "Manipuri",
    "Manx",
    "Maori",
    "Marathi",
    "Mauritian",
    "Melanau",
    "Melanesian",
    "Mestizo",
    "Metis",
    "Mexican",
    "Minangkabau",
    "Moldavian",
    "Mon",
    "Mongolian",
    "Moroccan",
    "Murut",
    "Naga",
    "Nauruan",
    "Negro",
    "Nepalese",
    "Netherlander",
    "New Zealander",
    "Newar",
    "Nigerian",
    "Norwegian",
    "Other Eurasian",
    "Other Indian",
    "Other Indonesian",
    "Others",
    "Pakistani",
    "Palestine",
    "Parsee",
    "Pathan",
    "Penan",
    "Persian",
    "Peruvian",
    "Pole",
    "Polish",
    "Polynesian",
    "Portuguese",
    "Punan",
    "Punjabi",
    "Rajput",
    "Rakhine",
    "Romanian",
    "Russian",
    "Sammarinese",
    "Samoan",
    "Scot",
    "Serani",
    "Serbia/montengerin",
    "Seychellois",
    "Shan",
    "Sikh",
    "Sindhi",
    "Sinhalese",
    "Sino Indian",
    "Sino Japanese",
    "Sino Kadazan",
    "Slavic",
    "Slovak",
    "Somali",
    "Spanish",
    "Sri Lankan",
    "Sudanese",
    "Sumatran",
    "Sundanese",
    "Swede",
    "Swedish",
    "Swiss",
    "Tajik",
    "Tamil",
    "Telugu",
    "Thai",
    "Tibetan",
    "Timor",
    "Tongan",
    "Turk",
    "Turkmen",
    "Ukrainian",
    "Unknown",
    "Uyghur",
    "Uzbek",
    "Venezuelan",
    "Vietnamese",
    "Welsh",
    "Yugoslav",
    "Zimbabwean",
  ],
  NATIONALITY: [
    "Afghan",
    "Albanian",
    "Algerian",
    "American",
    "American Samoan",
    "Andorran",
    "Angolan",
    "Anguillan",
    "Antarctica",
    "Antiguan",
    "Argentinian",
    "Armenian",
    "Australian",
    "Austrian",
    "Azerbaijani",
    "Bahamian",
    "Bahraini",
    "Bangladeshi",
    "Barbados",
    "Belarussian",
    "Belgian",
    "Belizean",
    "Beninese",
    "Bhutanese",
    "Bolivian",
    "Bosnian",
    "Botswana",
    "Brazilian",
    "British",
    "British National Overseas",
    "British Overseas Citizen",
    "British Overseas Territories Citizen",
    "British Protected Person",
    "British Subject",
    "Bruneian",
    "Bulgarian",
    "Burkinabe",
    "Burundian",
    "Cambodian",
    "Cameroonian",
    "Canadian",
    "Cape Verdean",
    "Central African Republic",
    "Chadian",
    "Chilean",
    "Chinese",
    "Chinese/hongkong Sar",
    "Chinese/macao Sar",
    "Colombian",
    "Comoran",
    "Congolese",
    "Cook Islander",
    "Costa Rican",
    "Croatian",
    "Cuban",
    "Cypriot",
    "Czech",
    "Czechoslovak",
    "D.p.r. Korean",
    "Danish",
    "Democratic Republic Of The Congo",
    "Djiboutian",
    "Dominican",
    "Dominican (republic)",
    "Dutch",
    "East Timorese",
    "Ecuadorian",
    "Egyptian",
    "Equatorial Guinea",
    "Eritrean",
    "Estonian",
    "Ethiopian",
    "Fijian",
    "Filipino",
    "Finnish",
    "Frence Southern Territories",
    "French",
    "French Guianese",
    "French Polynesian",
    "Gabon",
    "Gambian",
    "Georgian",
    "German",
    "German, East",
    "German, West",
    "Ghanaian",
    "Greek",
    "Grenadian",
    "Guadeloupian",
    "Guamanian",
    "Guatemalan",
    "Guinean",
    "Guinean (bissau)",
    "Guyanese",
    "Haitian",
    "Honduran",
    "Hungarian",
    "Icelander",
    "Indian",
    "Indonesian",
    "Iranian",
    "Iraqi",
    "Irish",
    "Israeli",
    "Italian",
    "Ivory Coast",
    "Jamaican",
    "Japanese",
    "Jordanian",
    "Kampuchean",
    "Kazakhstani",
    "Kenyan",
    "Kirghiz",
    "Kiribati",
    "Kittian & Nevisian",
    "Korean, South",
    "Kosovar",
    "Kuwaiti",
    "Kyrghis",
    "Kyrgyzstan",
    "Laotian",
    "Latvian",
    "Lebanese",
    "Lesotho",
    "Liberian",
    "Libyan",
    "Liechtensteiner",
    "Lithuanian",
    "Luxembourger",
    "Macedonian",
    "Madagasy",
    "Malawian",
    "Malaysian",
    "Maldivian",
    "Malian",
    "Maltese",
    "Marshallese",
    "Martiniquais",
    "Mauritanean",
    "Mauritian",
    "Mexican",
    "Micronesian",
    "Moldavian",
    "Monacan",
    "Mongolian",
    "Montenegrin",
    "Moroccan",
    "Mozambican",
    "Myanmar",
    "Namibian",
    "Nauruan",
    "Nepalese",
    "Netherlands",
    "Netherlands Antililles",
    "New Caledonia",
    "New Zealander",
    "Ni Vanuatu",
    "Nicaraguan",
    "Niger",
    "Nigerian",
    "Niuean",
    "Norwegian",
    "Omani",
    "Others",
    "Pacific Island Trust Territory",
    "Pakistani",
    "Palauan",
    "Palestinian",
    "Panamanian",
    "Papua New Guinean",
    "Paraguayan",
    "Peruvian",
    "Pitcairn",
    "Polish",
    "Portuguese",
    "Puerto Rican",
    "Qatari",
    "Refugee (other Than Xxb)",
    "Refugee (xxb)",
    "Reunionese",
    "Romanian",
    "Russian",
    "Rwandan",
    "Sahrawi",
    "Salvadoran",
    "Sammarinese",
    "Samoan",
    "Sao Tomean",
    "Saudi Arabian",
    "Senegalese",
    "Serbian",
    "Seychellois",
    "Sierra Leone",
    "Singapore Citizen",
    "Slovak",
    "Slovenian",
    "Solomon Islander",
    "Somali",
    "South African",
    "South Sudanese",
    "Spanish",
    "Sri Lankan",
    "St. Lucia",
    "St. Vincentian",
    "Stateless",
    "Sudanese",
    "Surinamer",
    "Swazi",
    "Swedish",
    "Swiss",
    "Syrian",
    "Tadzhik",
    "Taiwanese",
    "Tajikistani",
    "Tanzanian",
    "Thai",
    "Timorense",
    "Togolese",
    "Tokelauan",
    "Tongan",
    "Trinidadian & Tobagonian",
    "Tunisian",
    "Turk",
    "Turkmen",
    "Tuvalu",
    "Ugandan",
    "Ukrainian",
    "United Arab Emirates",
    "Unknown",
    "Upper Volta",
    "Uruguayan",
    "Uzbekistan",
    "Vatican City State (holy See)",
    "Venezuelan",
    "Vietnamese",
    "Wallis And Futuna Islanders",
    "Yemen Arab Rep",
    "Yemen, South",
    "Yemeni",
    "Yugoslavians",
    "Zairan",
    "Zambian",
    "Zimbabwean",
  ],
  MEDICAL_RIGHTS_CLAIM: [
    { translation: "general.medicalRightsClaimInsuranceCompany", value: "Insurance Company" },
    { translation: "general.medicalRightsClaimOfficial", value: "Official" },
    { translation: "general.medicalRightsClaimSelfPayment", value: "Self-Payment" },
  ],
  ALLERGIES_SELECT: [
    { label: "general.noKnownAllergies", value: "No Known Allergies" },
    { label: "general.yes", value: "Yes" },
  ],
  BLOOD_GROUP: [
    { label: "A", value: "A" },
    { label: "B", value: "B" },
    { label: "O", value: "O" },
    { label: "AB", value: "AB" },
  ],
  RHESUS: [
    { label: "general.positive", value: "Positive" },
    { label: "general.negative", value: "Negative" },
  ],
  ACTIVENESS: [
    { label: "general.active", value: "Active" },
    { label: "general.inactive", value: "Inactive" },
  ],
  TEST_MODEL: {
    name: "Keith",
    Occupation: "PO",
  },
  TRANSFEROPTIONS: [
    { value: "Credit", text: "custom.credit" },
    { value: "membershipPoint", text: "report.membershipPoint" },
    { value: "virtualCurrency", text: "setting.inventoryType.virtualCurrency" },
  ],
  PATIENT_FORM: {
    patientType: "",
    givenId: "",
    name: "",
    nric: "",
    nricType: "A",
    title: "",
    countryOfBirth: "Singapore",
    gender: "",
    maritalStatus: "",
    nationality: "Singapore Citizen",
    dateOfBirth: "",
    startDate: "",
    race: "",
    postal: "",
    address: "",
    unit: "",
    email: "",
    telephone: "",
    regionCode: "",
    otherRegionCode: "",
    mobile: "",
    emergencyContacts: [
      {
        nextOfKin: "",
        nextOfKinRelationship: "",
        nextOfKinRelationshipOthers: "",
        nextOfKinEmail: "",
        nextOfKinPhone: "",
      },
    ],
    drugAllergiesSelect: "",
    drugAllergiesSelected: "",
    drugAllergies: "",
    drugAllergiesList: [],
    foodAllergiesSelect: "",
    foodAllergies: "",
    foodAllergiesList: [],
    medication: "",
    currentMedication: "",
    medicalComplains: "",
    g6pdDeficiency: "",
    foodSymptom: "",
    drugSymptom: "",
    rhesus: "",
    signature: "",
    signatureDate: "",
    note: "",
    alerts: "",
    activeness: "Active",
    questionnaireFormData: {
      have_you_seen: [], // need this to be set initially to array so its not treated as boolean
      medicalProblemYes: [], // map with schema default form data
    },
    adultRegistrationFormData: {},
    childRegistrationFormData: {},
    corpInsurance: [
      {
        _id: "",
        policyHolderName: "",
        membershipNo: "",
        policyStartDate: "",
        membershipExpiry: "",
      },
    ],
    familyMembers: [],
    others: "",
    homeNumberRegionCode: "",
    otherHomeNumberRegionCode: "",
    test: "",
    localTitle: "",
    localName: "",
  },
  PATIENT_REFERREDBY: [
    { label: "patientReferredBy.advertisement", value: "Advertisement" },
    { label: "patientReferredBy.closeToHome", value: "Close to Home/Work" },
    { label: "patientReferredBy.doctorReferral", value: "Doctor Referral" },
    { label: "patientReferredBy.family", value: "Family" },
    { label: "patientReferredBy.friend", value: "Friend" },
    {
      label: "patientReferredBy.ispecially",
      value: "I specially contacted my doctor who has previously treated me",
    },
    { label: "patientReferredBy.internet", value: "Internet" },
    { label: "patientReferredBy.magazine", value: "Magazine" },
    { label: "patientReferredBy.newspaper", value: "News Paper" },
    { label: "patientReferredBy.publicTalksSeminars", value: "Public Talks/Seminars" },
    { label: "patientReferredBy.socialMedia", value: "Social Media" },
    { label: "patientReferredBy.internalMarketing", value: "internal Marketing" },
    { label: "patientReferredBy.others", value: "Others" },
  ],
  PATIENT_REFERREDBY_OC: [
    { label: "patientReferredBy.google", value: "Google" },
    { label: "patientReferredBy.facebook", value: "Facebook" },
    { label: "patientReferredBy.instagram", value: "Instagram" },
    { label: "patientReferredBy.youtube", value: "YouTube" },
    { label: "patientReferredBy.friendsFamily", value: "Friends/Family" },
    { label: "patientReferredBy.others", value: "Others" },
  ],
  PATIENT_REFERREDBY_TCM: [
    { label: "patientReferredBy.personalReferral", value: "Personal Referral" },
    { label: "patientReferredBy.google", value: "Google" },
    { label: "patientReferredBy.website", value: "Website" },
    { label: "patientReferredBy.socialMedia", value: "Social Media" },
    {
      label: "patientReferredBy.insurancePersonalCorporate",
      value: "Insurance (Personal/corporate)",
    },
  ],
  PATIENT_REFERREDBY_OTHERS: "Others",
  PATIENT_REFERREDBY_DOCTOR: "Doctor Referral",
  PATIENT_REFERREDBY_PERSONAL_REFERRAL: "Personal Referral",
  PATIENT_REFERREDBY_PERSONAL_INSURANCE_PERSONAL: "Insurance (Personal/corporate)",
  PAYMENT_MODE_OPTIONS: {
    cash: "Cash",
    paynow: "PayNow",
    paylah: "PayLah",
    union_pay: "Union Pay",
    offset_deposit: "Offset-Deposit",
    wirecard: "Wirecard",
    apple_pay: "Apple Pay",
    ali_pay: "AliPay",
    wechat_pay: "WeChat Pay",
    nets: "NETS",
    mastercard: "MasterCard",
    visa: "Visa",
    amex: "Amex",
    paypal: "Paypal",
    cheque: "Cheque",
    bank_transfer: "Bank Transfer",
    giro: "GIRO",
    online_payment: "Online Payment",
    refund: "Refund",
    credit_redeem: "Credit Redeem",
    package_transfer: "Package Transfer",
    bad_debts: "Bad Debts",
    diners: "Diners",
    jcb: "JCB",
    others: "Others",
    na: "N/A",
  },
  INVENTORY_TYPES_WITH_BATCH: {
    Medicine: "setting.inventoryType.medicine",
    Consumables: "setting.inventoryType.consumables",
    Expendables: "setting.inventoryType.expendables",
    Vaccination: "setting.inventoryType.vaccination",
    Product: "setting.inventoryType.product",
  },
  INVENTORY_TYPES: {
    Medicine: "setting.inventoryType.medicine",
    Consumables: "setting.inventoryType.consumables",
    Expendables: "setting.inventoryType.expendables",
    Service: "setting.inventoryType.service",
    Therapy: "setting.inventoryType.therapy",
    Teleconsult: "setting.inventoryType.teleconsult",
    Package: "setting.inventoryType.package",
    Bundle: "setting.inventoryType.bundle",
    Investigation: "setting.inventoryType.investigation",
    Referral: "setting.inventoryType.referral",
    Injection: "setting.inventoryType.injection",
    Vaccination: "setting.inventoryType.vaccination",
    Misc: "setting.inventoryType.misc",
    Credit: "setting.inventoryType.credit",
    "Virtual Currency": "setting.inventoryType.virtualCurrency",
    Compounded: "setting.inventoryType.compounded",
    Product: "setting.inventoryType.product",
    "Nursing Procedure": "setting.inventoryType.nursingProcedure",
    Consultation: "setting.inventoryType.consultation",
    Laboratory: "setting.inventoryType.laboratory",
    Radiology: "setting.inventoryType.radiology",
    "Professional Fees Consult": "setting.inventoryType.professionalFeesConsult",
    "Professional Fees Procedures": "setting.inventoryType.professionalFeesProcedures",
    Facilities: "setting.inventoryType.facilities",
    "Health Screening": "setting.inventoryType.healthScreening",
    "Order Set": "setting.inventoryType.orderSet",
    Scanning: "setting.inventoryType.scanning",
  },
  INVENTORY_TYPES_MAKUANG: {
    Wyn: "setting.inventoryType.wyn",
  },
  IMPORT_INVENTORY_TYPES_MAKUANG: {
    Wyn: "Wyn",
  },
  IMPORT_INVENTORY_TYPES: {
    Medicine: "Medicine",
    Consumables: "Consumables",
    Expendables: "Expendables",
    Service: "Service",
    Therapy: "Therapy",
    Teleconsult: "Teleconsult",
    Package: "Package",
    Bundle: "Bundle",
    Investigation: "Investigation",
    Referral: "Referral",
    Injection: "Injection",
    Vaccination: "Vaccination",
    Misc: "Misc",
    Credit: "Credit",
    "Virtual Currency": "Virtual Currency",
    Compounded: "Compounded",
    Product: "Product",
    "Nursing Procedure": "Nursing Procedure",
    Consultation: "Consultation",
    Laboratory: "Laboratory",
    Radiology: "Radiology",
    "Professional Fees Consult": "Professional Fees Consult",
    "Professional Fees Procedures": "Professional Fees Procedures",
    Facilities: "Facilities",
    "Health Screening": "Health Screening",
    "Order Set": "Order Set",
    Scanning: "Scanning",
  },
  SUPPORTED_BONUS_INVENTORY_TYPES: [
    "Service",
    "Therapy",
    "Teleconsult",
    "Nursing Procedure",
    "Consultation",
  ],
  INVENTORY_UOM: {
    AMP: "AMP",
    B100: "B100",
    B1000: "B1000",
    B10PC: "B10PC",
    B12R: "B12R",
    B14: "B14",
    "B3.8L": "B3.8L",
    B3DZ: "B3DZ",
    B500: "B500",
    B50P: "B50P",
    B50PC: "B50PC",
    BAG: "BAG",
    BK100: "BK100",
    BK20: "BK20",
    BL100: "BL100",
    BOT: "BOT",
    "BOT.": "BOT.",
    BOT1: "BOT1",
    BOT2: "BOT2",
    BOT4: "BOT4",
    BOT60: "BOT60",
    BOTCC: "BOTCC",
    BOTTL: "BOTTL",
    BOX: "BOX",
    BOX1: "BOX1",
    BOX10: "BOX10",
    BOX12: "BOX12",
    BOX14: "BOX14",
    BOX16: "BOX16",
    BOX2: "BOX2",
    BOX21: "BOX21",
    BOX24: "BOX24",
    BOX25: "BOX25",
    BOX28: "BOX28",
    BOX30: "BOX30",
    BOX4: "BOX4",
    BOX5: "BOX5",
    BOX50: "BOX50",
    BOX6: "BOX6",
    BOXES: "BOXES",
    BP100: "BP100",
    BT100: "BT100",
    BT120: "BT120",
    BT200: "BT200",
    "BT3.8": "BT3.8",
    BT30: "BT30",
    BT300: "BT300",
    BT5: "BT5",
    BT500: "BT500",
    BT90: "BT90",
    BTL: "BTL",
    "BTL.": "BTL.",
    BTL8: "BTL8",
    BX: "BX",
    "BX 12": "BX 12",
    "BX 60": "BX 60",
    BX10: "BX10",
    BX100: "BX100",
    BX12: "BX12",
    BX14: "BX14",
    BX150: "BX150",
    BX18: "BX18",
    BX1K: "BX1K",
    BX2: "BX2",
    BX20: "BX20",
    BX200: "BX200",
    BX20P: "BX20P",
    BX250: "BX250",
    BX28: "BX28",
    BX30: "BX30",
    BX300: "BX300",
    BX32: "BX32",
    BX36: "BX36",
    BX400: "BX400",
    BX48: "BX48",
    BX5: "BX5",
    BX50: "BX50",
    BX500: "BX500",
    BX60: "BX60",
    BX700: "BX700",
    CAN: "CAN",
    CAP: "CAP",
    "CART.": "CART.",
    CASE: "CASE",
    CC: "CC",
    CN100: "CN100",
    CN150: "CN150",
    CT300: "CT300",
    CTN: "CTN",
    CTN1: "CTN1",
    CTN12: "CTN12",
    CTN18: "CTN18",
    CTN2: "CTN2",
    CTN24: "CTN24",
    CTN5: "CTN5",
    CTN50: "CTN50",
    CTN80: "CTN80",
    INJ: "INJ",
    KIT: "KIT",
    METRE: "METRE",
    ML: "ML",
    PACK: "PACK",
    PACK1: "PACK1",
    PAIR: "PAIR",
    PC: "PC",
    PC3: "PC3",
    PCS: "PCS",
    PESS: "PESS",
    PIECE: "PIECE",
    PK: "PK",
    PK1: "PK1",
    PK100: "PK100",
    PK15: "PK15",
    PKT: "PKT",
    PKT1: "PKT1",
    PKT5: "PKT5",
    ROLL: "ROLL",
    ROLL1: "ROLL1",
    ROLLS: "ROLLS",
    SAC: "SAC",
    SACH: "SACH",
    SET: "SET",
    STR: "STR",
    STRIP: "STRIP",
    SYR: "SYR",
    TAB: "TAB",
    "TAB.1": "TAB.1",
    TEST: "TEST",
    TEST1: "TEST1",
    TUB: "TUB",
    TUBE: "TUBE",
    TUBE1: "TUBE1",
    VIAL: "VIAL",
    VIAL1: "VIAL1",
    YARD: "YARD",
  },
  INVENTORY_UOM_CN_TR: {
    pill: "pill",
    tablet: "tablet",
    drop: "drop",
    ml: "ml",
    piece: "piece",
    cm: "cm",
    pack: "pack",
    pellet: "pellet",
    bag: "bag",
    bottle: "bottle",
    box: "box",
    spray: "spray",
  },
  INVOICE_FIELD: {
    LINEITEM: {
      AFTER_TAX_PRICE: "afterTaxPrice",
      QTY: "qty",
      PRICE: "price",
      DISCOUNT: "discount",
      DISCOUNT_TYPE: "discountType",
      TAX: "tax",
      DESCRIPTION: "description",
      INDICATION: "indication",
      INDICATIONLOCAL: "indicationLocal",
      INSTRUCTION: "instruction",
      INSTRUCTIONLOCAL: "instructionLocal",
      INSTRUCTIONINFO: "instructionInfo",
      PRECAUTION1: "precaution1",
      PRECAUTION1LOCAL: "precaution1Local",
      PRECAUTION2: "precaution2",
      PRECAUTION2LOCAL: "precaution2Local",
      DOSAGE: "dosage",
      DOSAGELOCAL: "dosageLocal",
      LABEL: "label",
      EXPIRY: "expiry",
      SELECTEDBATCH: "selectedBatch",
      REDEEMED_POINT: "redeemedPoint",
      REDEEM_QTY: "redeemQty",
      CONSULTANTS: "consultants",
      THERAPISTS: "therapists",
      PROVIDERS: "providers",
      DURATION: "duration",
      CONCENTRATION_OF_SYRUP_MG: "concentrationOfSyrupMg",
      CONCENTRATION_OF_SYRUP_ML: "concentrationOfSyrupMl",
      DOSE_PER_KG: "dosePerKg",
    },
    ROUNDING_ENABLED: "roundingEnabled",
  },
  ORDER_FIELD: {
    LINEITEM: {
      PURCHASING_UNIT_ORDERED: "purchasingUnitOrdered",
      QTY_ORDERED: "qtyOrdered",
      QTY: "qty",
      UNIT_PRICE: "price",
      BATCH_NO: "batch",
      EXPIRY: "expiry",
      AMT: "amount",
    },
    ROUNDING_ENABLED: "roundingEnabled",
  },
  CLINIC_ROLES: {
    provider: {
      VALUE: "Provider",
      EQUIV: "Doctor",
      LABEL: "setting.providerForm.doctorName",
      LOCAL_LABEL: "setting.providerForm.doctorLocalName",
      ID: "setting.providerForm.doctor",
    },
    therapist: {
      VALUE: "Therapist",
      EQUIV: "Therapist",
      LABEL: "setting.providerForm.therapistName",
      LOCAL_LABEL: "setting.providerForm.therapistLocalName",
      ID: "setting.providerForm.therapist",
    },
    consultant: {
      VALUE: "Consultant",
      EQUIV: "Consultant",
      LABEL: "setting.providerForm.consultantName",
      LOCAL_LABEL: "setting.providerForm.consultantLocalName",
      ID: "setting.providerForm.consultant",
    },
  },
  CORPORATE_TYPES: {
    Corporate: "Corporate",
    Insurance: "Insurance",
    Hospital: "Hospital",
  },
  CLINIC_TYPE: {
    Clinic: "Clinic",
    Retail: "Retail",
    Salon: "Salon",
  },
  CORPORATE_TYPES_LIST: [
    { text: "general.corporate", value: "Corporate" },
    { text: "general.insurancecompay", value: "Insurance" },
    { text: "general.hospital", value: "Hospital" },
    { text: "setting.none", value: "None" },
  ],
  APPOINTMENT_STATUSES: {
    Scheduled: "scheduled",
    Attended: "attended",
    Cancelled: "cancelled",
    NoShow: "noShow",
    Available: "Available",
    Confirmed: "confirmed",
    Completed: "completed",
    Approved: "approved",
    Rejected: "rejected",
  },
  APPOINTMENT_TYPE: {
    TELE_PATIENT_REMOTE: "general.teleConsultPatientRemote",
    TELE_PROVIDER_REMOTE: "general.teleConsultProviderRemote",
    NORMAL: "general.normal",
  },
  OT_APPOINTMENT_STATUSES: {
    Pending: "pending",
    AwaitingInvestigations: "awaitingInvestigations",
    NoSlot: "noSlotAvailable",
    Scheduled: "scheduled",
  },
  OT_BOOKING_STATUSES: {
    PENDING: "general.otBookingPending",
    APPROVED: "general.otBookingApproved",
    AWAITING: "general.otBookingAwaitingInvestigation",
    DECLINED: "general.otBookingDeclined",
  },
  OT_SCHEDULE_STATUSES: {
    SCHEDULED: "general.otSchedScheduled",
    CALLED_FOR: "general.otSchedCalledFor",
    PRE_OP: "general.otSchedPreOp",
    INDUCTION: "general.otSchedInduction",
    KNIFE_SKIN: "general.otSchedKnifeToSkin",
    OP_END: "general.otSchedOpEnd",
    REVERSAL: "general.otSchedReversal",
    OUT_OF_OT: "general.otSchedOutOfOT",
    POST_OP_RECOVERY: "general.otSchedPostOPRecovery",
    CLEANING: "general.otSchedCleaning",
    COMPLETE: "general.otSchedComplete",
  },
  YESNO: [
    { value: true, text: "Yes", i18nId: "general.yes" },
    { value: false, text: "No", i18nId: "general.no" },
  ],
  LETTER_BUILDER_HELPER: {
    PATIENT: [
      { value: "", text: "", disabled: true },
      { value: "{patient.title}", text: "setting.letterPatient.title" },
      { value: "{patient.name}", text: "setting.letterPatient.name" },
      { value: "{patient.nric}", text: "setting.letterPatient.nric" },
      { value: "{patient.givenId}", text: "setting.letterPatient.givenId" },
      { value: "{patient.localName}", text: "general.localName" },
      { value: "{patient.localTitle}", text: "general.localTitle" },
      { value: "{patient.age}", text: "setting.letterPatient.age" },
      { value: "{patient.address}", text: "setting.letterPatient.address" },
      { value: "{patient.mobile}", text: "setting.letterPatient.mobile" },
    ],
    DATE: [
      { value: "", text: "", disabled: true },
      { value: "{date.today_date}", text: "Today's Date" },
      { value: "{date.one_day_later}", text: "Date (1 Day Later)" },
      { value: "{date.three_days_later}", text: "Date (3 Days Later)" },
    ],
    DATE_GENERAL: [
      { value: "{date.today_date}", text: "setting.letterDate.todaydate" },
      { value: "{date.today_date_en}", text: "setting.letterDate.todaydateEN" },
      { value: "{date.timestamp}", text: "setting.letterDate.timestamp" },
      { value: "{date.day}", text: "setting.letterDate.day" },
    ],
    DATE_BUSINESS_DAYS_ONLY: [
      { value: "{date.one_b_day_later}", text: "setting.letterDate.businessdayAfter1" },
      { value: "{date.three_b_days_later}", text: "setting.letterDate.businessdayAfter2" },
      { value: "{date.five_b_days_later}", text: "setting.letterDate.businessdayAfter3" },
    ],
    DATE_ALL_DAYS: [
      { value: "{date.one_day_later}", text: "setting.letterDate.alldayLater1" },
      { value: "{date.three_days_later}", text: "setting.letterDate.alldayLater3" },
      { value: "{date.five_days_later}", text: "setting.letterDate.alldayLater5" },
      { value: "{date.two_weeks_later}", text: "setting.letterDate.alldayWeek2" },
      { value: "{date.one_month_later}", text: "setting.letterDate.alldayMonth1" },
      { value: "{date.two_months_later}", text: "setting.letterDate.alldayMonth2" },
      { value: "{date.three_months_later}", text: "setting.letterDate.alldayMonth3" },
      { value: "{date.six_months_later}", text: "setting.letterDate.alldayMonth6" },
    ],
    DOCTOR: [
      { value: "{provider.name}", text: "setting.letterAttendingDr.name" },
      { value: "{provider.givenId}", text: "setting.letterAttendingDr.givenId" },
      { value: "{provider.role}", text: "setting.letterAttendingDr.role" },
      { value: "{provider.licenseNumber}", text: "setting.letterAttendingDr.mcrNumber" },
      { value: "{provider.email}", text: "setting.letterAttendingDr.email" },
      { value: "{provider.mobile}", text: "setting.letterAttendingDr.mobile" },
    ],
    CLINIC: [
      { value: "{clinic.name}", text: "setting.name" },
      { value: "{clinic.address}", text: "custom.address" },
      { value: "{clinic.phoneNumber}", text: "general.contact" },
    ],
    CLINIC_UAT: [
      { value: "{clinic.name}", text: "setting.name" },
      { value: "{clinic.address}", text: "custom.address" },
      { value: "{clinic.phoneNumber}", text: "general.contact" },
      { value: "{config.clinicLocalName}", text: "setting.clinicLocalName" },
      { value: "{config.clinicLocalAddress}", text: "setting.clinicLocalAddress" },
    ],
    REFERRAL: [
      { value: "{referral.name}", text: "setting.letterReferralInfo.name" },
      { value: "{referral.category}", text: "setting.letterReferralInfo.category" },
      { value: "{referral.description}", text: "setting.letterReferralInfo.description" },
      { value: "{referral.address}", text: "setting.letterReferralInfo.address" },
      { value: "{referral.telephone}", text: "setting.letterReferralInfo.contact" },
      { value: "{referral.fax}", text: "setting.letterReferralInfo.fax" },
      { value: "{referral.email}", text: "setting.letterReferralInfo.email" },
    ],
    CAL_NO_MC_DAYS: [
      { value: "{date.from_date}", text: "setting.letterDate.fromDate" },
      { value: "{date.from_date_en}", text: "setting.letterDate.fromDateEN" },
      { value: "{date.to_date}", text: "setting.letterDate.toDate" },
      { value: "{date.to_date_en}", text: "setting.letterDate.toDateEN" },
      { value: "{date.days}", text: "setting.letterDate.numberOfDays" },
    ],
    REMARKS: [
      { value: "{remarks.medCertNo}", text: "setting.letterRemarks.medCertNo" },
      { value: "{remarks.diagnosis}", text: "setting.letterRemarks.diagnosis" },
      { value: "{remarks.inventoryName}", text: "setting.letterRemarks.inventoryName" },
      { value: "{remarks.batchNo}", text: "setting.letterRemarks.batchNo" },
      { value: "{remarks.expiryDate}", text: "setting.letterRemarks.expiryDate" },
    ],
  },
  CONFIG_INVENTORY: [
    {
      label: "Allow expendables type of inventory to be sellable",
      field: "expendablesAreSellable",
      i18nId: "setting.expendablesAreSellable",
    },
  ],
  CONFIG_INVENTORY_CATEGORYFIELDS: [
    {
      label: "Type",
      field: "type",
      tdClass: "vcenter",
      i18nId: "general.type",
    },
    {
      label: "Category",
      field: "category",
      tdClass: "vcenter",
      i18nId: "general.category",
    },
    {
      label: "Actions",
      field: "action",
      width: "100px",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "general.action",
    },
  ],
  CONFIG_INVOICE_CATEGORYFIELDS: [
    {
      label: "Type",
      field: "type",
      tdClass: "vcenter",
      i18nId: "general.type",
    },
    {
      label: "Category",
      field: "category",
      tdClass: "vcenter",
      i18nId: "general.category",
    },
    {
      label: "Combined",
      field: "combined",
      width: "100px",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "general.combined",
    },
  ],
  CONFIG_PATIENT_MANDATORYFIELDS: [
    {
      label: "Patient Type",
      field: "patientType",
      i18nId: "general.patientType",
    },
    {
      label: "Mobile Number",
      field: "mobNumber",
      i18nId: "general.mobile",
    },
    {
      label: "NRIC",
      field: "nric",
      i18nId: "general.idDocNumber",
    },
    {
      label: "Email Address",
      field: "emailAdd",
      i18nId: "general.emailAddress",
    },
    {
      label: "Date of Birth",
      field: "dob",
      i18nId: "general.dateOfBirth",
    },
    {
      label: "Drug Allergies",
      field: "drugAllergies",
      i18nId: "general.drugAllergies",
    },
    {
      label: "Nationality",
      field: "nationality",
      i18nId: "general.nationality",
    },
    {
      label: "Food Allergies",
      field: "foodAllergies",
      i18nId: "general.foodAllergy",
    },
    {
      label: "Corporate / Insurance",
      field: "corpInsurance",
      i18nId: "general.corpInsurance",
    },
    {
      label: "Patient Id",
      field: "givenId",
      i18nId: "general.patientId",
    },
    {
      label: "Patient Gender",
      field: "gender",
      i18nId: "general.gender",
    },
    {
      label: "Country of Birth",
      field: "countryOfBirth",
      i18nId: "general.countryOfBirth",
    },
  ],
  CONFIG_PATIENT_REGISTRATION_OPTIONS: [
    {
      label: "Show clinic logo",
      field: "showClinicLogo",
      i18nId: "setting.showClinicLogo",
    },
    {
      label: "Mobile Number to be unique",
      field: "uniqueMobileNumber",
      i18nId: "setting.uniqueMobileNumber",
    },
    {
      label: "Prefix Patient ID with Clinic Code",
      field: "prefixPatientIdWithClinicCode",
      i18nId: "setting.prefixPatientIdWithClinicCode",
    },
    {
      label: "Zero Pad Patient ID",
      field: "zeroPaddPatientID",
      i18nId: "setting.zeroPaddPatientID",
    },
    {
      label: "Serialize Patient ID by clinic Code",
      field: "serializePatientID",
      i18nId: "setting.serializePatientID",
    },
  ],
  CONFIG_PATIENT_VITALSFIELDS: [
    {
      label: "Code",
      field: "code",
      width: "90px",
      i18nId: "setting.code",
    },
    {
      label: "Name",
      field: "name",
      i18nId: "general.name",
    },
    {
      label: "Unit",
      field: "unit",
      i18nId: "general.unit",
    },
    {
      label: "Other Code",
      field: "extCode",
      i18nId: "general.otherCode",
    },
    {
      label: "Active",
      field: "active",
      i18nId: "general.active",
    },
    {
      label: "Mandatory",
      field: "mandatory",
      i18nId: "general.mandatory",
    },
    {
      label: "Actions",
      field: "action",
      width: "100px",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "general.action",
    },
  ],
  CONFIG_INTEGRATED_TEST_STATUS_HEADER: [
    {
      label: "Code",
      field: "code",
      i18nId: "setting.code",
    },
    {
      label: "Pre-Status Action Name (optional)",
      field: "labelName",
      i18nId: "general.preStatusActionName",
    },
    {
      label: "Name",
      field: "name",
      i18nId: "general.name",
    },
    // {
    //     label: 'Symbols',
    //     field: 'icon',
    //     i18nId: 'general.symbols',
    // },
    {
      label: "Actions",
      field: "action",
      width: "100px",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "general.action",
    },
  ],
  CONFIG_INVENTORY_PRINTPURCHASEORDERFIELDS: [
    {
      label: "Supplier Name",
      field: "supplierName",
      i18nId: "order.supplierName",
    },
    {
      label: "Supplier Address",
      field: "supplierAddress",
      i18nId: "order.supplierAddress",
    },
    {
      label: "Clinic Name",
      field: "clinicName",
      i18nId: "setting.clinicName",
    },
    {
      label: "Clinic Address",
      field: "clinicAddress",
      i18nId: "setting.address",
    },
    {
      label: "Purchase Order Number",
      field: "purchaseOrderNumber",
      i18nId: "order.purchaseOrderNo",
    },
    {
      label: "Purchase Order Created Date",
      field: "purchaseOrderCreatedDate",
      i18nId: "order.purchaseOrderCreatedDate",
    },
    {
      label: "Item Rate",
      field: "itemRate",
      i18nId: "order.itemRate",
    },
    {
      label: "Tax Rate",
      field: "taxRate",
      i18nId: "general.taxRate",
    },
    {
      label: "Line Item Amount",
      field: "lineItemAmount",
      i18nId: "order.lineItemAmount",
    },
    {
      label: "Subtotal, Tax, and Total Amount",
      field: "subtotalTaxAndTotalAmount",
      i18nId: "order.subtotalTaxAndTotalAmount",
    },
    {
      label: "Notes",
      field: "notes",
      i18nId: "general.notes",
    },
  ],
  CONFIG_PATIENT_TAGS: [
    {
      label: "Name",
      field: "name",
      i18nId: "general.name",
    },
    {
      label: "Symbols",
      field: "icon",
      i18nId: "general.symbols",
    },
    {
      label: "Actions",
      field: "action",
      width: "100px",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "general.action",
    },
  ],
  CONFIG_PATIENT_PRINTLABELFIELDS: [
    {
      label: "Clinic Name",
      field: "clinicName",
      i18nId: "setting.clinicName",
    },
    {
      label: "Patient Date of Birth",
      field: "patientDOB",
      i18nId: "setting.dateOfBirth",
    },
    {
      label: "Clinic Address",
      field: "clinicAddress",
      i18nId: "setting.address",
    },
    {
      label: "Patient ID",
      field: "patientID",
      i18nId: "general.patientId",
    },
    {
      label: "Patient Name",
      field: "patientName",
      i18nId: "general.patientName",
    },
    {
      label: "Patient Sex",
      field: "patientSex",
      i18nId: "setting.gender",
    },
    {
      label: "Patient NRIC/FIN",
      field: "nricfin",
      i18nId: "setting.idDocNumber",
    },
    {
      label: "Nationality",
      field: "nationality",
      i18nId: "setting.nationality",
    },
    {
      label: "Test",
      field: "patientTest",
      i18nId: "general.patientTest",
    },
    {
      label: "Patient Age",
      field: "age",
      i18nId: "setting.patientAge",
    },
    {
      label: "Patient Address",
      field: "address",
      i18nId: "general.patientAddress",
    },
    {
      label: "Mobile Number",
      field: "mobile",
      i18nId: "general.mobile",
    },
    {
      label: "Doctor Name",
      field: "doctorName",
      i18nId: "Doctor Name",
    },
    {
      label: "Visit Datetime",
      field: "visitDateTime",
      i18nId: "Visit Datetime",
    },
  ],
  CONFIG_PATIENT_MAILINGLABELFIELDS: [
    {
      label: "Clinic Name",
      field: "clinicName",
      i18nId: "setting.clinicName",
    },
    {
      label: "Patient Date of Birth",
      field: "patientDOB",
      i18nId: "setting.dateOfBirth",
    },
    {
      label: "Clinic Address",
      field: "clinicAddress",
      i18nId: "setting.address",
    },
    {
      label: "Patient ID",
      field: "patientID",
      i18nId: "general.patientId",
    },
    {
      label: "Patient Name",
      field: "patientName",
      i18nId: "general.patientName",
    },
    {
      label: "Patient Sex",
      field: "patientSex",
      i18nId: "setting.gender",
    },
    {
      label: "Patient NRIC/FIN",
      field: "nricfin",
      i18nId: "setting.idDocNumber",
    },
    {
      label: "Nationality",
      field: "nationality",
      i18nId: "setting.nationality",
    },
    {
      label: "Test",
      field: "patientTest",
      i18nId: "general.patientTest",
    },
    {
      label: "Patient Age",
      field: "age",
      i18nId: "setting.patientAge",
    },
    {
      label: "Patient Address",
      field: "address",
      i18nId: "general.patientAddress",
    },
    {
      label: "Mobile Number",
      field: "mobile",
      i18nId: "general.mobile",
    },
    {
      label: "Doctor Name",
      field: "doctorName",
      i18nId: "Doctor Name",
    },
    {
      label: "Visit Datetime",
      field: "visitDateTime",
      i18nId: "Visit Datetime",
    },
  ],
  CONFIG_PATIENT_PRINTCONSULTNOTEFIELDS: [
    {
      label: "Clinic Logo",
      field: "clinicLogo",
      i18nId: "setting.logo",
    },
    {
      label: "Clinic Name",
      field: "clinicName",
      i18nId: "setting.clinicName",
    },
    {
      label: "Clinic Address",
      field: "clinicAddress",
      i18nId: "setting.address",
    },
    {
      label: "Patient Address",
      field: "patientAddress",
      i18nId: "general.patientAddress",
    },
    {
      label: "Doctor Name",
      field: "doctorName",
      i18nId: "general.doctorName",
    },
    {
      label: "Therapist Name",
      field: "therapistName",
      i18nId: "general.therapistName",
    },
    {
      label: "Patient Name",
      field: "patientName",
      i18nId: "general.patientName",
    },
    {
      label: "Patient NRIC",
      field: "patientNRIC",
      i18nId: "general.patientNRIC",
    },
    {
      label: "Patient Date of Birth",
      field: "patientDOB",
      i18nId: "general.dateOfBirth",
    },
    {
      label: "Patient Gender",
      field: "patientGender",
      i18nId: "general.patientGender",
    },
    {
      label: "Patient Nationality",
      field: "patientNationality",
      i18nId: "general.nationality",
    },
    {
      label: "Medical Service",
      field: "medicalServices",
      i18nId: "general.medicalServices",
    },
    {
      label: "Visit Date",
      field: "visitDate",
      i18nId: "general.visitDate",
    },
  ],
  CONFIG_PATIENT_PRINTLETTERHEADERFIELDS: [
    {
      label: "Clinic Logo",
      field: "clinicLogo",
      i18nId: "setting.logo",
    },
    {
      label: "Clinic Name",
      field: "clinicName",
      i18nId: "setting.clinicName",
    },
    {
      label: "Clinic Address",
      field: "clinicAddress",
      i18nId: "setting.address",
    },
    {
      label: "Clinic Phone",
      field: "clinicPhone",
      i18nId: "setting.telephone",
    },
    {
      label: "Today's Date",
      field: "todayDate",
      i18nId: "setting.todayDate",
    },
    {
      label: "Today's Date in BE",
      field: "todayDateBE",
      i18nId: "setting.todayDateBE",
    },
    {
      label: "Printed Date and Time",
      field: "printedDateTime",
      i18nId: "setting.printedDateTime",
    },
    {
      label: "Patient ID",
      field: "patientID",
      i18nId: "general.patientId",
    },
    {
      label: "Patient Name",
      field: "patientName",
      i18nId: "general.patientName",
    },
    {
      label: "Patient NRIC/FIN",
      field: "nricfin",
      i18nId: "setting.idDocNumber",
    },
    {
      label: "Patient Sex",
      field: "patientSex",
      i18nId: "setting.gender",
    },
    {
      label: "Patient Date of Birth",
      field: "patientDOB",
      i18nId: "setting.dateOfBirth",
    },
    {
      label: "Clinic Local Name",
      field: "clinicLocalName",
      i18nId: "setting.clinicLocalName",
    },
    {
      label: "Clinic Local Address",
      field: "clinicLocalAddress",
      i18nId: "setting.clinicLocalAddress",
    },
    {
      label: "Patient Local Name",
      field: "patientLocalName",
      i18nId: "general.patientLocalName",
    },
    {
      label: "Patient Age",
      field: "patientAge",
      i18nId: "general.patientAge",
    },
  ],
  CONFIG_PATIENT_PRINTLETTERFOOTERFIELDS: [
    {
      label: "Clinic Name",
      field: "clinicName",
      i18nId: "setting.clinicName",
    },
    {
      label: "Clinic Address",
      field: "clinicAddress",
      i18nId: "setting.address",
    },
    {
      label: "Clinic Phone",
      field: "clinicPhone",
      i18nId: "setting.telephone",
    },
    {
      label: "Today's Date",
      field: "todayDate",
      i18nId: "setting.todayDate",
    },
    {
      label: "Today's Date in BE",
      field: "todayDateBE",
      i18nId: "setting.todayDateBE",
    },
    {
      label: "Printed Date and Time",
      field: "printedDateTime",
      i18nId: "setting.printedDateTime",
    },
    {
      label: "Patient ID",
      field: "patientID",
      i18nId: "general.patientId",
    },
    {
      label: "Patient Name",
      field: "patientName",
      i18nId: "general.patientName",
    },
    {
      label: "Patient NRIC/FIN",
      field: "nricfin",
      i18nId: "setting.idDocNumber",
    },
    {
      label: "Patient Sex",
      field: "patientSex",
      i18nId: "setting.gender",
    },
    {
      label: "Patient Date of Birth",
      field: "patientDOB",
      i18nId: "setting.dateOfBirth",
    },
    {
      label: "Clinic Local Name",
      field: "clinicLocalName",
      i18nId: "setting.clinicLocalName",
    },
    {
      label: "Clinic Local Address",
      field: "clinicLocalAddress",
      i18nId: "setting.clinicLocalAddress",
    },
    {
      label: "Patient Local Name",
      field: "patientLocalName",
      i18nId: "general.patientLocalName",
    },
    {
      label: "Patient Age",
      field: "patientAge",
      i18nId: "general.patientAge",
    },
  ],
  CONFIG_PATIENT_PRINTPACKAGEFIELDS: [
    {
      label: "Clinic Logo",
      field: "clinicLogo",
      i18nId: "setting.logo",
    },
  ],
  CONFIG_PATIENT_PRINTPRESCRIPTIONFIELDS: [
    {
      label: "Clinic Logo",
      field: "clinicLogo",
      i18nId: "setting.logo",
    },
    {
      label: "Clinic Name",
      field: "clinicName",
      i18nId: "setting.clinicName",
    },
    {
      label: "Clinic Address",
      field: "clinicAddress",
      i18nId: "setting.address",
    },
    {
      label: "Name",
      field: "patientName",
      i18nId: "prescriptionConfig.patientName",
    },
    {
      label: "Gender",
      field: "patientGender",
      i18nId: "prescriptionConfig.patientGender",
    },
    {
      label: "Age",
      field: "patientAge",
      i18nId: "prescriptionConfig.patientAge",
    },
    {
      label: "Weight",
      field: "patientWeight",
      i18nId: "prescriptionConfig.patientWeight",
    },
    {
      label: "Tel",
      field: "patientTelephone",
      i18nId: "prescriptionConfig.patientTelephone",
    },
    {
      label: "Patient ID",
      field: "patientID",
      i18nId: "prescriptionConfig.patientId",
    },
    {
      label: "VN",
      field: "patientVN",
      i18nId: "prescriptionConfig.patientVN",
    },
    {
      label: "Service Type",
      field: "serviceType",
      i18nId: "prescriptionConfig.serviceType",
    },
    {
      label: "Diagnosis",
      field: "diagnosis",
      i18nId: "prescriptionConfig.diagnosis",
    },
    {
      label: "Skin Test",
      field: "patientSkinTest",
      i18nId: "prescriptionConfig.patientSkinTest",
    },
    {
      label: "Date",
      field: "invoiceDate",
      i18nId: "prescriptionConfig.invoiceDate",
    },
    {
      label: "Allergies",
      field: "allergies",
      i18nId: "prescriptionConfig.allergies",
    },
  ],
  CONFIG_INVOICE_PRINTFIELDS: [
    {
      label: "Clinic Logo",
      field: "clinicLogo",
      i18nId: "setting.logo",
    },
    {
      label: "Doctor Name",
      field: "docName",
      i18nId: "setting.providerName",
    },
    {
      label: "Invoice Date in BE",
      field: "invoiceDateBE",
      i18nId: "setting.invoiceDateBE",
    },
    {
      label: "Clinic Name (Local)",
      field: "clinicLocalName",
      i18nId: "setting.clinicLocalName",
    },
    {
      label: "Clinic Address",
      field: "clinicAdd",
      i18nId: "setting.address",
    },
    {
      label: "Clinic Address (Local)",
      field: "clinicLocalAddress",
      i18nId: "setting.clinicLocalAddress",
    },
    {
      label: "Doctor Qualifications",
      field: "docQual",
      i18nId: "setting.providerQualifications",
    },
    {
      label: "Patient Name",
      field: "patientName",
      i18nId: "general.patientName",
    },
    {
      label: "Patient Name (Local)",
      field: "patientLocalName",
      i18nId: "setting.patientLocalName",
    },
    {
      label: "NRIC",
      field: "nric",
      i18nId: "general.nric",
    },
    {
      label: "Patient ID",
      field: "patientGivenIdFull",
      i18nId: "general.patientId",
    },
    {
      label: "Patient Address",
      field: "patientAdd",
      i18nId: "setting.patientAddress",
    },
    {
      label: "Patient Phone No.",
      field: "patientPhoneNo",
      i18nId: "setting.patientPhoneNo",
    },
    {
      label: "Therapist Name",
      field: "therapistName",
      i18nId: "setting.therapistName",
    },
    {
      label: "Diagnosis",
      field: "diagnosis",
      i18nId: "general.diagnosis",
    },
    {
      label: "Description of Line Items",
      field: "lineItemsDesc",
      i18nId: "setting.lineItemDescription",
    },
    {
      label: "Item Batch",
      field: "batch",
      i18nId: "setting.itemBatch",
    },
    {
      label: "Tax Registration Number",
      field: "regNumber",
      i18nId: "setting.gstRegNo",
    },
    {
      label: "Payment Time",
      field: "paymentTime",
      i18nId: "setting.paymentTime",
    },
    {
      label: "Notes",
      field: "notes",
      i18nId: "general.notes",
    },
    {
      label: "Invoice Footer",
      field: "footer",
      i18nId: "setting.invoiceFooter",
    },
    {
      label: "Footer - Clinic/Hospital",
      field: "clinicHospital",
      i18nId: "setting.footerClinicHospital",
    },
    {
      label: "Footer - Patient Signature",
      field: "patientSignature",
      i18nId: "setting.footerPatientSignature",
    },
    {
      label: "Redeemed Point",
      field: "membership",
      i18nId: "general.membershipPointBalance",
    },
    {
      label: "Virtual Currency",
      field: "virtualCurrency",
      i18nId: "general.virtualCurrencyBalance",
    },
    {
      label: "Outstanding Balance",
      field: "ostBalance",
      i18nId: "general.outstandingBalance",
    },
  ],
  CONFIG_INVOICE_CORPORATE_PRINTFIELDS: [
    {
      label: "Clinic Logo",
      field: "clinicLogo",
      i18nId: "setting.logo",
    },
    {
      label: "Clinic Name (Local)",
      field: "clinicLocalName",
      i18nId: "setting.clinicLocalName",
    },
    {
      label: "Doctor Name",
      field: "docName",
      i18nId: "setting.providerName",
    },
    {
      label: "Clinic Address",
      field: "clinicAdd",
      i18nId: "setting.address",
    },
    {
      label: "Clinic Address (Local)",
      field: "clinicLocalAddress",
      i18nId: "setting.clinicLocalAddress",
    },
    {
      label: "Invoice Date in BE",
      field: "invoiceDateBE",
      i18nId: "setting.invoiceDateBE",
    },
    {
      label: "Doctor Qualifications",
      field: "docQual",
      i18nId: "setting.providerQualifications",
    },
    {
      label: "Patient Name (Local)",
      field: "patientLocalName",
      i18nId: "setting.patientLocalName",
    },
    {
      label: "Patient Address",
      field: "patientAdd",
      i18nId: "setting.patientAddress",
    },
    {
      label: "Therapist Name",
      field: "therapistName",
      i18nId: "setting.therapistName",
    },
    {
      label: "Diagnosis",
      field: "diagnosis",
      i18nId: "general.diagnosis",
    },
    {
      label: "Description of Line Items",
      field: "lineItemsDesc",
      i18nId: "setting.lineItemDescription",
    },
    {
      label: "Tax Registration Number",
      field: "regNumber",
      i18nId: "setting.gstRegNo",
    },
    {
      label: "Notes",
      field: "notes",
      i18nId: "general.notes",
    },
    {
      label: "Invoice Footer",
      field: "footer",
      i18nId: "setting.invoiceFooter",
    },
    {
      label: "Footer - Clinic/Hospital",
      field: "clinicHospital",
      i18nId: "setting.footerClinicHospital",
    },
    {
      label: "Footer - Patient Signature",
      field: "patientSignature",
      i18nId: "setting.footerPatientSignature",
    },
    {
      label: "Company Name",
      field: "companyName",
      i18nId: "general.companyName",
    },
    {
      label: "Company Address",
      field: "companyAddress",
      i18nId: "general.companyAddressConfig",
    },
  ],
  CONFIG_INVOICE_ROUNDING_SELECTION: {
    NONE: "setting.none",
    ROUND0P05: "setting.roundToNearest5Cent",
    ROUND1P00: "setting.roundToNearestDollar",
    ROUND1U00: "setting.roundUpToNearestDollar",
    ROUND0D10: "setting.roundDownToNearest10Cent",
    ROUND1D00: "setting.roundDownToNearestDollar",
  },
  CONFIG_INVOICE_ROUNDING_SELECTION_FOR_LINEITEM_TOTAL: {
    ROUNDTOTAL: "setting.roundToTotal",
    ROUNDLINEITEM: "setting.roundToLineItem",
  },
  CONFIG_APPOINTMENT_MANDATORYFIELDS: [
    {
      label: "Category",
      field: "category",
      i18nId: "general.category",
    },
    {
      label: "Medical Service",
      field: "medService",
      i18nId: "general.serviceType",
    },
    {
      label: "Room",
      field: "room",
      i18nId: "general.room",
    },
    {
      label: "Provider",
      field: "provider",
      i18nId: "general.provider",
    },
    {
      label: "Therapist",
      field: "therapist",
      i18nId: "general.therapist",
    },
    {
      label: "Consultant",
      field: "consultant",
      i18nId: "general.consultant",
    },
    {
      label: "Appointment Details",
      field: "apptmntDetails",
      i18nId: "general.appointmentDetails",
    },
  ],
  CONFIG_APPOINTMENT_HOVERFIELDS: [
    {
      label: "Appointment Details",
      field: "apptmntDetails",
      i18nId: "general.appointmentDetails",
    },
    {
      label: "Category",
      field: "category",
      i18nId: "general.category",
    },
    {
      label: "Type",
      field: "type",
      i18nId: "general.type",
    },
    {
      label: "Service",
      field: "medService",
      i18nId: "general.serviceType",
    },
    {
      label: "Room",
      field: "room",
      i18nId: "general.room",
    },
    {
      label: "Provider",
      field: "provider",
      i18nId: "general.provider",
    },
    {
      label: "Therapist",
      field: "therapist",
      i18nId: "general.therapist",
    },
    {
      label: "Consultant",
      field: "consultant",
      i18nId: "general.consultant",
    },
    {
      label: "Secondary Provider ",
      field: "secondaryProvider",
      i18nId: "general.secondaryProvider",
    },
    {
      label: "Organiser",
      field: "organiser",
      i18nId: "general.organiser",
    },
  ],
  CONFIG_APPOINTMENT_FIELDS_TO_SYNC: [
    {
      label: "Appointment Details",
      field: "apptDetails",
      i18nId: "general.appointmentDetails",
    },
    {
      label: "Category",
      field: "category",
      i18nId: "general.category",
    },
    {
      label: "Type",
      field: "apptType",
      i18nId: "general.type",
    },
    {
      label: "Medical Service",
      field: "medService",
      i18nId: "general.serviceType",
    },
    {
      label: "Room",
      field: "room",
      i18nId: "general.room",
    },
    {
      label: "Provider",
      field: "provider",
      i18nId: "general.provider",
    },
    {
      label: "Therapist",
      field: "therapist",
      i18nId: "general.therapist",
    },
    {
      label: "Consultant",
      field: "consultant",
      i18nId: "general.consultant",
    },
    {
      label: "Secondary Provider",
      field: "secondaryProvider",
      i18nId: "general.secondaryProvider",
    },
    {
      label: "Organiser",
      field: "organiser",
      i18nId: "general.organiser",
    },
  ],
  CONFIG_APPOINTMENT_CATEGORYFIELDS: [
    {
      label: "Name",
      field: "name",
      tdClass: "vcenter",
      i18nId: "general.name",
    },
    {
      label: "Description",
      field: "desc",
      tdClass: "vcenter",
      i18nId: "general.description",
    },
    {
      label: "Color",
      field: "color",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "setting.color",
    },
    {
      label: "Icon",
      field: "icon",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "setting.icon",
    },
    {
      label: "Actions",
      field: "action",
      width: "100px",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "general.action",
    },
  ],
  CONFIG_APPOINTMENT_DRAGONCARE_CATEGORY_FIELDS: [
    {
      label: "Name",
      field: "name",
      tdClass: "vcenter",
      i18nId: "general.name",
    },
    {
      label: "Description",
      field: "desc",
      tdClass: "vcenter",
      i18nId: "general.description",
    },
    {
      label: "Remote",
      field: "isRemote",
      tdClass: "vcenter",
      i18nId: "general.remote",
    },
    {
      label: "Actions",
      field: "action",
      width: "100px",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "general.action",
    },
  ],
  CONFIG_INVOICE_REQUEST_APPROVAL_FIELDS: [
    {
      label: "Dispensing",
      field: "dispense",
      i18nId: "general.dispense",
    },
    {
      label: "Remove",
      field: "remove",
      i18nId: "general.remove",
    },
    {
      label: "Increase Qty",
      field: "increaseQty",
      i18nId: "setting.increaseQty",
    },
    {
      label: "Reduce Qty",
      field: "reduceQty",
      i18nId: "setting.reduceQty",
    },
    {
      label: "Price",
      field: "price",
      i18nId: "general.price",
    },
    {
      label: "Discount",
      field: "discount",
      i18nId: "general.discount",
    },
  ],
  NOTIFICATION_TEMPLATE_VARIABLES: [
    {
      value: "{patient.name}",
      text: "setting.medServiceForm.patientName",
    },
    {
      value: "{patient.localName}",
      text: "setting.medServiceForm.patientLocalName",
    },
    {
      value: "{appointment.schedule}",
      text: "setting.medServiceForm.appointmentSchedule",
    },
    {
      value: "{appointment.appointmentScheduleBE}",
      text: "setting.medServiceForm.appointmentScheduleBE",
    },
    {
      value: "{appointment.service}",
      text: "setting.medServiceForm.appointmentService",
    },
    {
      value: "{clinic.name}",
      text: "setting.medServiceForm.clinicName",
    },
    {
      value: "{clinic.localName}",
      text: "setting.medServiceForm.clinicLocalName",
    },
    {
      value: "{clinic.address}",
      text: "setting.medServiceForm.clinicAddress",
    },
    {
      value: "{clinic.localAddress}",
      text: "setting.medServiceForm.clinicLocalAddress",
    },
    {
      value: "{clinic.phone}",
      text: "setting.medServiceForm.clinicPhone",
    },
    {
      value: "{appointment.confirmPaymentLink}",
      text: "setting.medServiceForm.appointmentConfirmPaymentLink",
    },
    {
      value: "{appointment.confirmLink}",
      text: "setting.medServiceForm.appointmentConfirmLink",
    },
    {
      value: "{patient.registration}",
      text: "setting.medServiceForm.patientRegLink",
    },
    {
      value: "{appointment.appointmentQRCodeLink}",
      text: "setting.medServiceForm.appointmentQRCodeLink",
    },
  ],
  QRCODE_TEMPLATE_VARIABLES: [
    {
      value: "{patient.name}",
      text: "setting.medServiceForm.patientName",
    },
    {
      value: "{clinic.name}",
      text: "setting.medServiceForm.clinicName",
    },
    {
      value: "{clinic.address}",
      text: "setting.medServiceForm.clinicAddress",
    },
    {
      value: "{clinic.phone}",
      text: "setting.medServiceForm.clinicPhone",
    },
    {
      value: "{appointment.appointmentInvitedLink}",
      text: "setting.medServiceForm.appointmentInvitedLink",
    },
  ],
  MEMBERSHIP: {
    POINTS_DEDUCTION: {
      AUTO: "AUTO",
      MANUAL: "MANUAL",
    },
    ACTIVATION_TYPE: {
      MANUAL: "MANUAL",
      SPENDING: "SPENDING",
    },
    CALCULATION_PERIODS: {
      CURRENT_TIER_12_MONTHS: "membership.calcPeriod12months",
      CALENDAR_YEAR: "membership.calcPeriodCalYear",
      MONTH_24: "membership.calcPeriod24Month", // translated
      INVOICE: "membership.onInvoice",
    },
    QUALIFICATION_TYPE: {
      POINT: "POINT",
      CASH: "CASH",
    },
    TRANSACTION_TYPES: {
      P: "general.purchase",
      PROMO: "membership.promotion",
      R: "membership.redeemed",
      AU: "membership.adjustUp",
      AD: "membership.adjustDown",
      T: "transferPoint.transfer",
      W: "tableHeader.welcomePoints",
      TO: "transferPoint.transferOut",
      TI: "transferPoint.transferIn",
      VP: "membership.voidPurchase",
      VPROMO: "membership.voidPromotion",
      VR: "membership.voidRedeem",
      VW: "membership.voidWelcome",
      CREDIT_NOTE: "membership.creditNote",
    },
    TRANSACTION_TYPES_NIKS: {
      P: "general.purchase",
      PROMO: "membership.promotion",
      R: "membership.redeemed",
      AU: "membership.adjustUp",
      AD: "membership.adjustDown",
      T: "transferPoint.transfer",
      W: "tableHeader.welcomePointsNiks",
      TO: "transferPoint.transferOut",
      TI: "transferPoint.transferIn",
      VP: "membership.voidPurchase",
      VPROMO: "membership.voidPromotion",
      VR: "membership.voidRedeem",
      VW: "membership.voidWelcome",
      CREDIT_NOTE: "membership.creditNote",
    },

    TEMPLATE_POINTS_OPTIONS: {
      PENM: "membership.PENM",
      RPBL: "membership.RPBL",
      P1ME: "membership.P1ME",
      P2ME: "membership.P2ME",
      P3ME: "membership.P3ME",
      P4ME: "membership.P4ME",
      P5ME: "membership.P5ME",
      P6ME: "membership.P6ME",
      PRNM: "membership.PRNM",
    },
    TEMPLATE_TIERS_OPTIONS: {
      CURRENT_TIER: "membership.currentTier",
      NEXT_TIER: "membership.nextTier",
    },
    TEMPLATE_GENERAL_OPTIONS: {
      COMPANY_LOGO: "setting.companyLogo",
      PATIENT_NAME: "general.patientName",
      TITLE: "general.title",
      NRIC: "pharmacy.nric",
    },
    TEMPLATE_DATE_OPTIONS: {
      DAY_1: {
        D1BL: "membership.D1BL",
        D3BL: "membership.D3BL",
        D5BL: "membership.D5BL",
        TODAY: "membership.today",
      },
      DAY_2: {
        D1L: "membership.D1L",
        D1W: "membership.D1W",
        D1M: "membership.D1M",
        D3M: "membership.D3M",
      },
    },
    TEMPLATE_TRIGGER_DATE: {
      W1: "1 Week Before Expiry",
      W2: "2 Week Before Expiry",
      W3: "3 Week Before Expiry",
      M1: "1 Month Before Expiry",
    },
  },
  PHARMACY_MEDS_FIELDS: [
    {
      labelKey: "pharmacy.colGivenId",
      field: "medicine.givenId",
      tdClass: "vcenter med-given-id",
    },
    {
      labelKey: "pharmacy.colPicture",
      field: "medicine.thumbnailURL",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      sortable: false,
    },
    {
      labelKey: "pharmacy.colMedName",
      field: "medicine.name",
      tdClass: "vcenter",
    },
    {
      labelKey: "pharmacy.colBatch",
      field: "batch.number",
      thClass: "text-center",
      tdClass: "text-center vcenter",
    },
    {
      labelKey: "Bar code",
      field: "Bar code",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      sortable: false,
    },
    {
      labelKey: "pharmacy.colQuantity",
      field: "quantity",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      sortable: false,
    },
    {
      labelKey: "pharmacy.colStatus",
      field: "status",
      thClass: "text-center",
      tdClass: "text-center vcenter",
    },
    {
      labelKey: "pharmacy.colAction",
      field: "newStatus",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      sortable: false,
    },
    {
      labelKey: "pharmacy.colStatusDate",
      field: "statusDate",
      tdClass: "vcenter",
    },
    {
      labelKey: "pharmacy.colLabel",
      field: "label",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      sortable: false,
    },
    {
      labelKey: "pharmacy.colPrint",
      field: "print",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      sortable: false,
    },
  ],
  PHARMACY_STATUS_TYPES: [
    { value: "Confirmed", i18nId: "pharmacy.confirmed" },
    { value: "Corrected", i18nId: "pharmacy.corrected" },
    { value: "Executed", i18nId: "pharmacy.executed" },
    { value: "Voided", i18nId: "pharmacy.voided" },
  ],
  IPD_PHARMACY_STATUS_TYPES: [
    { value: "CANCELLED", i18nId: "pharmacy.cancelled" },
    { value: "REQUESTED", i18nId: "pharmacy.requested" },
    { value: "EXECUTED", i18nId: "pharmacy.executed" },
    { value: "CLARIFY_AND_EXECUTED", i18nId: "pharmacy.clarifiedExecuted" },
    { value: "CLARIFY_AND_CANCELLED", i18nId: "pharmacy.clarifiedCancelled" },
  ],
  IPD_PHARMACY_STATUS: {
    CANCELLED: "CANCELLED",
    PENDING: "REQUESTED",
    EXECUTED: "EXECUTED",
    CLARIFY_AND_EXECUTED: "CLARIFY_AND_EXECUTED",
    CLARIFY_AND_CANCELLED: "CLARIFY_AND_CANCELLED",
  },
  IPD_PHARMACY_STATUS_LABEL: {
    CANCELLED: "pharmacy.cancelled",
    REQUESTED: "pharmacy.requested",
    EXECUTED: "pharmacy.executed",
    CLARIFY_AND_EXECUTED: "pharmacy.clarifiedExecuted",
    CLARIFY_AND_CANCELLED: "pharmacy.clarifiedCancelled",
  },
  IPD_PHARMACY_ACTION_LABEL: {
    EXECUTED: "pharmacy.execute",
    CLARIFY_AND_EXECUTED: "pharmacy.clarifyExecute",
    CLARIFY_AND_CANCELLED: "pharmacy.clarifyCancel",
  },
  IPD_PRESCRIPTION_STATUS: {
    ACTIVE: "ACTIVE",
    REQUESTED: "REQUESTED",
    CANCELLED: "CANCELLED",
    STOPPED: "STOPPED",
    COMPLETED: "COMPLETED",
  },
  IPD_PRESCRIPTION_STATUS_LABEL: {
    ACTIVE: "general.active",
    REQUESTED: "pharmacy.requested",
    CANCELLED: "pharmacy.cancelled",
    STOPPED: "pharmacy.stopped",
    COMPLETED: "general.completed",
  },
  IPD_PRESCRIPTION_CONTROLLED_STATUS: {
    PENDING: "PENDING",
  },
  IPD_PRESCRIPTION_CONTROLLED_STATUS_LABEL: {
    PENDING: "general.pending",
  },
  IPD_ADMINISTRATION_STATUS_LABEL: {
    all: "general.all",
    administered: "general.administered",
    notAdministered: "general.notAdministered",
  },
  ADMINISTRATION_LOGS_STATUS_LABEL: {
    SERVED: "Served",
    DELAYED: "Delayed",
    MISSED: "Missed",
    REFUSED: "Refused",
    HELD: "Held",
  },
  ADMINISTRATION_LOGS_STATUS: {
    SERVED: "SERVED",
    DELAYED: "DELAYED",
    MISSED: "MISSED",
    REFUSED: "REFUSED",
    HELD: "HELD",
  },
  ANAESTHESIA_EVENTS_LABEL: {
    NIL: "inpatient.nil",
    HYPOTENSION: "inpatient.hypotension",
    ECG_ISCHAEMIA: "inpatient.eCGIschaemia",
    ARRHYTHMIA: "inpatient.arrhythmia",
    DUG_ERROR: "inpatient.dugError",
    PERSISTENT_SP02: "inpatient.persistentSp02",
    Hypothermia: "inpatient.hypothermia",
    ALLERGIC_REACTION: "inpatient.allergicReaction",
    ASPIRATION: "inpatient.aspiration",
    BRONCHOSPASM: "inpatient.bronchospasm",
    LARYGOSPASM: "inpatient.larygospasm",
    FAILED_INTUBATION: "inpatient.failedIntubation",
    DENTAL_DAMAGE: "inpatient.dentalDamage",
    MULTIPLE_INTUBATION_ATTEMPTS: "inpatient.multipleIntubationAttempts",
    UNPLANNED_ICU_ADMISSION: "inpatient.unplannedICUadmission",
    CARDIAC_ARREST: "inpatient.cardiacArrest",
    DEATH: "inpatient.death",
  },
  ALDRETE_SCORE: {
    ASA2: 2,
    ASA1: 1,
    ASA0: 0,
    ASR2: 2,
    ASR1: 1,
    ASR0: 0,
    ASC2: 2,
    ASC1: 1,
    ASC0: 0,
    ASO22: 2,
    ASO21: 1,
    ASO20: 0,
    "": 0,
  },
  ALDRETE_SCORE_ACTIVITY_LABEL: {
    ASA2: "postOperative.moveAllExtremities",
    ASA1: "postOperative.moves2Extremeties",
    ASA0: "postOperative.cannotMoveExtremities",
  },
  ALDRETE_SCORE_ACTIVITY_SCORE: {
    ASA2: 2,
    ASA1: 1,
    ASA0: 0,
  },
  ALDRETE_SCORE_RESPIRATIONS_LABEL: {
    ASR2: "postOperative.breathesDeeply",
    ASR1: "postOperative.dyspneicShollowLimitBreathing",
    ASR0: "postOperative.apneic",
  },
  ALDRETE_SCORE_RESPIRATIONS_SCORE: {
    ASR2: 2,
    ASR1: 1,
    ASR0: 0,
  },
  ALDRETE_SCORE_CIRCULATION_LABEL: {
    ASC2: "postOperative.preanesthiticLevelHigher20mmHg",
    ASC1: "postOperative.preanesthiticLevelBetween2050mmHg",
    ASC0: "postOperative.preanesthiticLevelHigher50mmHg",
  },
  ALDRETE_SCORE_CIRCULATION_SCORE: {
    ASC2: 2,
    ASC1: 1,
    ASC0: 0,
  },
  ALDRETE_SCORE_O2_SITURATION_LABEL: {
    ASO22: "postOperative.roomAirHigher92Percent",
    ASO21: "postOperative.oxygenLevelHigher90Percent",
    ASO20: "postOperative.sautrationLess90PercentO2",
  },
  ALDRETE_SCORE_O2_SITURATION_SCORE: {
    ASO22: 2,
    ASO21: 1,
    ASO20: 0,
  },
  BROMAGE_SCALE_SCORE: {
    BS0: 0,
    BS1: 1,
    BS2: 2,
    BS3: 3,
    "": 0,
  },
  BROMAGE_SCALE_LABEL: {
    BS0: "postOperative.ableToLiftLegs",
    BS1: "postOperative.ableToFlexKnee",
    BS2: "postOperative.ableToMoveFeet",
    BS3: "postOperative.unableToMoveJoints",
  },
  DISCHARGE_CHECKLIST_LABEL: {
    DCHKL0: "postOperative.awake",
    DCHKL1: "postOperative.minimalNausea",
    DCHKL2: "postOperative.vomitting",
    DCHKL3: "postOperative.stableVitalSign",
    DCHKL4: "postOperative.sustainedHeadlift",
    DCHKL5: "postOperative.painScoreLess4",
    DCHKL6: "postOperative.awa",
    DCHKL7: "postOperative.noActiveBleeding",
    DCHKL8: "postOperative.aldreteScore",
    DCHKL9: "postOperative.BromageScale",
  },
  DISCHARGE_CHECKLIST: {
    DCHKL0: "DCHKL0",
    DCHKL1: "DCHKL1",
    DCHKL2: "DCHKL2",
    DCHKL3: "DCHKL3",
    DCHKL4: "DCHKL4",
    DCHKL5: "DCHKL5",
    DCHKL6: "DCHKL6",
    DCHKL7: "DCHKL7",
    DCHKL8: "DCHKL8",
    DCHKL9: "DCHKL9",
  },
  DISCHARGE_TO: {
    WARD: "WARD",
    HD: "HD",
    ICU: "ICU",
  },
  WARD_INSTRUCTION_LABEL: {
    SPIRAL_EPIDURAL: "spinalEpiduralGiven",
    UPPER_LOWER_LIMB: "upperLowerLimbGiven",
  },
  WARD_INSTRUCTION: {
    SPIRAL_EPIDURAL: "SPIRAL_EPIDURAL",
    UPPER_LOWER_LIMB: "UPPER_LOWER_LIMB",
  },
  TASK_TYPE: {
    NORMAL: "NORMAL",
    DRUG_APPROVAL: "DRUG_APPROVAL",
  },
  DRUG_CLASSIFICATION_OPTION: {
    NORMAL: "Normal",
    CLASSIFIED: "Classified",
    OTC: "OTC",
    Prescription: "Prescription",
    Controlled: "Controlled",
  },
  DRUG_CLASSIFICATION_OPTION_KH: {
    OTC: "OTC",
    Prescription: "Prescription",
    Controlled: "Controlled",
  },
  DRUG_CLASSIFICATION: {
    NORMAL: "NORMAL",
    CLASSIFIED: "CLASSIFIED",
  },
  RULE_ENGINE_CONFIG: {
    PARAM_ACTION_LANG_MAP: {
      "Start Consult": "setting.ruleEngineStartConsult",
      "End Consult": "setting.ruleEngineEndConsult",
      "Start Treatment": "setting.ruleEngineStartTreatment",
      "End Treatment": "setting.ruleEngineEndTreatment",
      "Photo Taken": "setting.ruleEnginePhotoTaken",
      Call: "setting.ruleEngineCall",
      "Queue Number": "setting.ruleEngineQueueNum",
      Invoice: "setting.ruleEngineInvoice",
      Payment: "setting.ruleEnginePayment",
      Patient: "setting.ruleEnginePatient",
      Appointment: "setting.ruleEngineAppointment",
      "Consult Note": "setting.ruleEngineConsultNote",
      Vitals: "setting.ruleEngineVitals",
      "New Task": "setting.ruleEngineNewTask",
      "Added to Today's Queue": "setting.ruleEngineAddTodayQueue",
      "Removed to Today's Queue": "setting.ruleEngineRemTodayQueue",
      Created: "setting.ruleEngineCreated",
      Activated: "setting.ruleEngineActivated",
      Recorded: "setting.ruleEngineRecorded",
    },
    CONDITION_LANG_MAP: {
      is: "setting.ruleEngineCondIs",
      isnot: "setting.ruleEngineCondIsNot",
    },
    TYPE_LANG_MAP: {
      Queue: "setting.ruleEngineTypeQueue",
      General: "setting.ruleEngineTypeGeneral",
    },
    SELECT_PARAMETERS: [
      { action: "Start Consult", types: "Queue" },
      { action: "End Consult", types: "Queue" },
      { action: "Start Treatment", types: "Queue" },
      { action: "End Treatment", types: "Queue" },
      { action: "Photo Taken", types: "Queue" },
      { action: "Call", types: "Queue" },
      { action: "Queue Number", types: "Queue" },
      { action: "Invoice", types: "Invoice" },
      { action: "Payment", types: "Invoice" },
      { action: "Patient", types: "General" },
      { action: "Appointment", types: "General" },
      { action: "Consult Note", types: "General" },
      { action: "Vitals", types: "General" },
      { action: "New Task", types: "General" },
    ],
    SELECT_ACTION: [
      { action: "Added to Today's Queue", types: "Queue" },
      { action: "Removed to Today's Queue", types: "Queue" },
      { action: "Created", types: "General" },
      { action: "Activated", types: "General" },
      { action: "Recorded", types: "General" },
    ],
    start_consult: "Start Consult",
    end_consult: "End Consult",
    start_treatment: "Start Treatment",
    end_treatment: "End Treatment",
    photo_taken: "Photo Taken",
    call: "Call",
    queueNumber: "Queue Number",
    patient: "Patient",
    invoice: "Invoice",
    payment: "Payment",
    appoitment: "Appointment",
    consultNote: "Consult Note",
    vitals: "Vitals",
    newTask: "New Task",
    addedQueue: "Added to Today's Queue",
    removedQueue: "Removed to Today's Queue",
    created: "Created",
    activated: "Activated",
    recorded: "Recorded",
  },
  CONFIG_PAYMENT_MODES: [
    {
      label: "Name",
      field: "name",
      i18nId: "general.name",
    },
    {
      label: "Processing Value",
      field: "processValue",
      i18nId: "paymentMode.processValue",
      type: "Number",
    },
    {
      label: "Processing Type",
      field: "processType",
      i18nId: "paymentMode.processType",
    },
    {
      label: "Active",
      field: "hidden",
      width: "90px",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "general.active",
      sortable: false,
    },
    {
      label: "Actions",
      field: "action",
      width: "100px",
      thClass: "text-center",
      tdClass: "text-center vcenter",
      i18nId: "general.action",
      sortable: false,
    },
  ],
  QUEUE_CALLNUMBER_STATUS: {
    APPT: "APPT",
    URGENT: "URGENT",
  },
  QUEUE_CALLNUMBER_PREFIX: {
    APPT: "A",
    URGENT: "U",
    "": "",
  },
  CAMPAIGN_PROMO_TYPES: {
    BUYXGETY: "campaign.buyXGetX",
    DISCOUNT: "general.discount",
    FREEGIFT: "campaign.freeGift",
    COMPLEX: "campaign.complex",
    BIRTHDAY_BONUS: "campaign.birthdayBonus",
  },
  PATIENTS_QUANTITY_TYPES: {
    PERMONTH: "campaign.perMonth",
    PERBIRTHMONTH: "campaign.perBirthMonth",
    PERYEAR: "campaign.perYear",
    NOLIMIT: "campaign.noLimit",
  },
  CAMPAIGN_BUYXGETX_ITEMTYPES: {
    ANY: "campaign.anyItem",
    ANY_MEDICINE: "campaign.anyMedicine",
    ANY_CONSUMABLES: "campaign.anyConsumables",
    ANY_EXPENDABLES: "campaign.anyExpendables",
    ANY_SERVICE: "campaign.anyService",
    ANY_PACKAGE: "campaign.anyPackage",
    ANY_BUNDLE: "campaign.anyBundle",
    ANY_INVESTIGATION: "campaign.anyInvestigation",
    ANY_REFERRAL: "campaign.anyReferral",
    ANY_INJECTION: "campaign.anyInjection",
    ANY_VACCINATION: "campaign.anyVaccination",
    ANY_MISC: "campaign.anyMisc",
    ANY_CREDIT: "campaign.anyCredit",
    ANY_PRODUCT: "campaign.anyProduct",
    SPECIFIED: "campaign.specificItem",
  },
  CAMPAIGN_FIELDS: [
    {
      label: "general.promotion",
      field: "name",
      thClass: "text-left",
      tdClass: "text-left vcenter",
    },
    {
      label: "general.type",
      field: "promoType",
      thClass: "text-center",
      tdClass: "text-center vcenter",
    },
    {
      label: "campaign.qtyLimit",
      field: "quantityLimit",
      thClass: "text-center",
      tdClass: "text-center vcenter",
    },
    {
      label: "general.quantityAvailable",
      field: "quantityAvailable",
      thClass: "text-center",
      tdClass: "text-center vcenter",
    },
    {
      label: "general.item",
      field: "items",
      thClass: "text-center",
      tdClass: "text-center vcenter",
    },
    {
      label: "campaign.promoCode",
      field: "promoCode",
      thClass: "text-center",
      tdClass: "text-center vcenter",
    },
  ],
  CAMPAIGN_STATUS: {
    ACTIVE: "general.active",
    ENDED: "general.ended",
    UPCOMING: "general.upcoming",
  },
  CAMPAIGN_ELIGIBILITY: {
    ALL: "general.allCustomer",
    NONMEMBERS: "general.nonMembersOnly",
    MEMBERS: "general.membersOnly",
  },
  WAITLIST_STATUS: {
    Accepted: "approved",
    Rejected: "rejected",
    Pending: "pending",
    Cancelled: "cancelled",
  },
  WAITLIST_LABEL: {
    approved: "Accepted",
    rejected: "Rejected",
    pending: "Pending",
    cancelled: "Cancelled",
  },
  IMPORT_INVENTORY: {
    inventory: "Inventory Type*",
    givenId: "Given Id*",
    name: "Inventory Name*",
    chineseName: "Local Name*",
    description: "Description*",
    purchasingUnit: "Purchasing Unit", // Inventory Unit Conversion
    unit: "Inventory Unit / Dispense Unit*",
    qtyOfInventoryUnitPerPurchasingUnit: "Purchasing Contains*",
    price: "Selling Price (Default)*",
    priceMin: "Selling Price (min)*",
    cost: "Cost Price*",
    category: "Category*",
    defaultDispenseQty: "Default Dispense Qty*",
    stickers: "Default Label Qty*",
    drugClassification: "Drug Classification*",
    brandName: "Brand Name*",
    precaution1: "Precaution 1*",
    precaution2: "Precaution 2*",
    dosage: "Default Dosage*",
    tax: "Tax*",
    lowStockLimit: "Low Stock Limit*",
    trackStock: "Track Stock*",
    manufacturer: "Manufacturer*",
    strength: "Strength*",
    inactive: "Inactive*",
    creditAmount: "Credit Amount*",
    freeAmount: "Free Amount*",
    purchasedAmount: "Purchased Amount*",
    providerCommissionAmt: "Provider Commission Amount*",
    providerCommissionType: "Provider Commission Type*",
    therapistCommissionAmt: "Therapist Commission Amount*",
    therapistCommissionType: "Therapist Commission Type*",
    consultantCommissionAmt: "Consultant Commission Amount*",
    consultantCommissionType: "Consultant Commission Type*",
    consignment: "Consignment*",
    manufacturingBarcode: "Manufacturing Barcode*",
    accountingCode: "Accounting Code*",
    minOrderQty: "Minimum Order Quantity*",
    indication: "Indication*",
    indicationLocal: "Indication (Local)*",
    instruction: "Instruction*",
    instructionLocal: "Instruction (Local)*",
    dosageLocal: "Dosage (Local)*",
    precaution1Local: "Precaution 1 (Local)*",
    precaution2Local: "Precaution 2 (Local)*",
    thaiBillingGroup: "Thai Billing Group",
    location: "Location",
    pinyin: "Pinyin",
  },
  IMPORT_Employee_AS_Patient: {
    employeeID: "Employee ID",
    employeeNameTh: "Employee Name TH",
    employeeNameEN: "Employee Name EN",
    confirmDate: "Confirm Date",
    terminationDate: "Termination Date",
    idCardNo: "ID. Card No.",
    birthDate: "Birth Date ",
    gender: "Gender",
    benefitScheme1: "Benefit scheme 1 ",
    corporate1: "Corporate 1",
    benefitScheme2: "Benefit scheme 2",
    corporate2: "Corporate 2",
    email: "Office Email",
    mobile: "Mobile",
  },
  CSV_SAMPLE_EXPORT: [
    {
      inventory: "Medicine",
      givenId: "JDNJWJ",
      name: "Sample Medicine",
      chineseName: "",
      description: "Sample Medicine",
      purchasingUnit: "BOX", // Inventory Unit Conversion
      unit: "BOX",
      qtyOfInventoryUnitPerPurchasingUnit: "10",
      price: "350",
      priceMin: "350",
      cost: "300",
      category: "Medicine",
      defaultDispenseQty: "10",
      stickers: "10",
      drugClassification: "NORMAL",
      brandName: "Sample Brand Name",
      precaution1: "Test PRECAUTION 1",
      precaution2: "Test PRECAUTION 2",
      dosage: "Apply 1 1/2 AMP S - use as instructed",
      tax: "7",
      lowStockLimit: "10",
      trackStock: "true",
      manufacturer: "",
      strength: "",
      inactive: "false",
      creditAmount: "",
      freeAmount: "",
      purchasedAmount: "",
      providerCommissionAmt: "1",
      providerCommissionType: "value",
      therapistCommissionAmt: "1",
      therapistCommissionType: "percentage",
      consultantCommissionAmt: "1",
      consultantCommissionType: "percentage",
      consignment: "",
      manufacturingBarcode: "A12345",
      accountingCode: "",
      minOrderQty: 1,
      indication: "",
      indicationLocal: "",
      instruction: "",
      instructionLocal: "",
      dosageLocal: "",
      precaution1Local: "",
      precaution2Local: "",
      thaiBillingGroup: "1.1.1(3)",
      // remember to add new fields to exportCSV() at ImportInventory.vue!
    },
  ],
  COMMISSION_TYPE: {
    percentage: "percentage",
    value: "value",
  },
  TAG_ICON: [
    "thermometer-full",
    "gem",
    "exclamation-triangle",
    "lightbulb",
    "star",
    "bell",
    "asterisk",
    "bolt",
    "check-circle",
    "flag",
    "allergies",
    "eye",
    "fist-raised",
    "heart",
    "tags",
    "thumbs-up",
    "weight-hanging",
    "wheelchair",
    "user-slash",
    "running",
    "hand-holding-usd",
  ],
  MAX_DISPENSE_SEARCHRESULTS: 50,
  ORDER_SLIDER: "ORDER_SLIDER",
  OT_INVOICE: "OT_INVOICE",
  AREA_CLASSIFICATION: {
    OT: "OT",
    ADMISSION: "ADMISSION",
  },
  ADMISSION_STATUS: {
    PENDING: "PENDING",
    FORM_ACCEPTED: "FORM_ACCEPTED",
    PRE_ADMITTED: "PRE_ADMITTED",
    ADMITTED: "ADMITTED",
    LAMA: "LAMA",
    TRANSFERRED: "TRANSFERRED",
    PRE_DISCHARGE: "PRE_DISCHARGE",
    DISCHARGE: "DISCHARGE",
    AWAIT_PAYMENT: "AWAIT_PAYMENT",
    PAYMENT_RECEIVED: "PAYMENT_RECEIVED",
  },
  ADMISSION_STATUS_LABEL: {
    PRE_ADMITTED: "Pre Admitted",
    ADMITTED: "Admitted",
    LAMA: "LAMA",
    TRANSFERRED: "Transferred",
    PRE_DISCHARGE: "Pre Discharge",
    AWAIT_PAYMENT: "Awaiting Payment",
    PAYMENT_RECEIVED: "Payment Received",
    DISCHARGE: "Discharge",
  },
  BED_STATUS: {
    GWD: "GWD",
    VIP: "VIP",
    DS: "DS",
    NURSERY: "NURSERY",
    ICU: "ICU",
    DELIVERY: "DELIVERY",
    ISOLATION: "ISLOATION",
  },
  BED_STATUS_LABEL: {
    GWD: "GWD",
    VIP: "VIP",
    DS: "DS",
    NURSERY: "Nursery",
    ICU: "ICU",
    DELIVERY: "Delivery",
    ISOLATION: "Isolation",
  },
  BILLING_STATUS: {
    INSURANCE: "INSURANCE",
    SELF_PAID: "SELF_PAID",
    COMPANY: "COMPANY",
    LG: "LG",
    VIP: "VIP",
    VVIP: "VVIP",
    GOVT: "GOVT",
  },
  NURSING_INPUTOUTPUT_SECTIONS: {
    inputIVFluid: {
      ivFluids: "nursingIO.inputIVFluidIVFluids",
      oral: "nursingIO.inputIVFluidOral",
      nasogastricFeeding: "nursingIO.inputIVFluidNasogastricFeeding",
    },
    inputIVMed: {},
    inputBloodProduct: {},
    outputUrine: {},
    outputBowel: {},
    outputVomitous: {},
    outputDrainage: {},
  },
  BILLING_STATUS_LABEL: {
    INSURANCE: "Insurance",
    SELF_PAID: "Self Payment",
    COMPANY: "Company",
    LG: "LG",
    VIP: "VIP",
    VVIP: "VVIP",
    GOVT: "Government",
  },
  INVOICE_STATUS_LABEL: {
    OUTSTANDING: "general.corpInvOutstanding",
    FULLY_PAID: "general.corpInvFullyPaid",
    VOIDED: "general.voided",
  },
  PAYMENT_STATUS_LABEL: {
    RECORDED: "setting.ruleEngineRecorded",
    NOT_RECORDED: "general.notRecorded",
  },
  TREATMENTS_FIELDS: [
    "suppression",
    "growthHormone",
    "fsh",
    "hcg",
    "lutealSupport",
    "letrozole",
    "procedures",
  ],
  FET_TREATMENTS_FIELDS: [
    "progynova",
    "fsh50iu",
    "sildegra",
    "evorelPatch",
    "endometrin",
    "imProgesterone",
    "procedures",
    "progesterone",
  ],
  IUI_TREATMENTS_FIELDS: [
    "clomid",
    "letrozole",
    "progynova2mg",
    "fshiuday",
    "duphaston",
    "endometrin",
    "cyclogest",
    "progesterone",
  ],
  TCM_CONSULTATION_STATUS: {
    DRAFT: "Draft",
    FINALIZED: "Finalized",
  },
  VISIT_RECORD_STATUS: {
    DRAFT: "Draft",
    PUBLISHED: "Published",
  },
  // TODO: should use full en abbreviation key
  TCM_ACU_CATEGORY: ["Acupuncture"],
  UPLOAD_STATE: {
    PENDING: "PENDING",
    PROCESSING: "PROCESSING",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED",
  },
  LAB_TEST: {
    NATIONAL_ID_TYPES: {
      NIRC: "nirc",
      PASSPORT: "passport",
      FIN: "fin",
    },
    TEST_TYPE: {
      GASTRO_CLEAR: "GASTRO_CLEAR",
    },
  },
  CREDIT_MODES: {
    OFFSET: "Offset",
    REFUND: "Refund",
  },
  STATUS_SELECTION: {
    PENDING: "Pending",
    USE: "Use",
    DO_NOT_USE: "DoNotUse",
  },
  BONUS_PACKAGE_GIVEN_ID: "_BONUS_PACKAGE",
  DRAGONCARE_PATIENT_SYSTEM_TAG: {
    NO_SHOW: {
      name: "No Show",
      icon: "user-slash",
    },
    MISSED_MULTIPLE_APPTS: {
      name: "Missed Multiple Appointments",
      icon: "running",
    },
    DEPOSIT_PAID: {
      name: "Deposit Paid",
      icon: "hand-holding-usd",
    },
  },
  SELECTED_OPTION_MODULES: {
    CRITERIA: "criteria",
  },
  PRINT_STATUS: {
    PRINTING: "PRINTING",
    PRINTED: "PRINTED",
    FAILED: "FAILED",
  },
  CHART_REPORT: {
    UPDATE_TYPE: {
      CREATE: 1,
      UPDATE: 2,
    },
    REPORT_TYPE: {
      ICSI: "icsi",
      IUI: "iui",
      STC: "stc",
    },
    BASE_ICSI_REPORT_URL: "/icsi-report",
    BASE_STC_REPORT_URL: "/stc-report",
    BASE_IUI_REPORT_URL: "/iui-report",
  },
  BATCH_INVENTORY_TYPES: [
    "Medicine",
    "Wyn",
    "Consumables",
    "Expendables",
    "Product",
    "Vaccination",
  ],
  MAKUANG_REPORT_GROUP_BY: {
    DATE: "DATE",
    CLINIC: "CLINIC",
  },
  MOVEMENT_TYPE: {
    Order: "Order",
    Dispense: "Dispense",
    Transfer: "Transfer",
    Accepted_Transfer: "Accepted Transfer",
    Adjustment: "Adjustment",
    Credit_Offset: "Credit_Offset",
    Credit_Refund: "Credit_Refund",
    Debit: "Debit",
    Withdraw: "Withdraw",
    Return: "Return",
    Void: "Void",
    Held: "Held",
    Expired: "Expired",
  },
  LINKED_PAGE: {
    EDIT_PATIENT_DETAILS: "EditPatientDetails",
    INVOICE: "Invoice",
    CONSULTATION: "Consultation",
  },
  CORPORATE_INSURANCE: [
    "KINGSMED PTE. LTD",
    "THOMSON MEDICAL PTE LTD",
    "AIM & ASSOCIATES",
    "AUTISM PARTNERSHIP PTE LTD",
    "AIMS APAC PROPERTY MANAGEMENT PTE LTD",
    "CORDLIFE GROUP LIMITED",
    "C W LEE CLINIC FOR WOMEN & SURGERY P L",
    "SINGAPORE CHINESE GIRLS' SCHOOL",
    "WE ARE CARING PTE LTD",
    "WC CHENG O&G PRACTICE PTE LTD",
    "THOMSON FERTILITY CENTRE PTE LTD",
    "THOMSON HEALTHCARE SPECIALISTS' PTE LTD",
    "PRUDENTIAL ASSURANCE COMPANY SINGAPORE-LIFE OPERATIONS-NEW BUSINESS",
    "AIMS APAC REIT MANAGEMENT LIMITED",
    "MR PETER LIM AND FAMILY",
    "PRUDENTIAL ASSURANCE COMPANY SINGAPORE-GROUP UNDERWRITING",
    "INTERNATIONAL SPECIALIST MEDICAL SERVICES PTE LTD",
    "AIA Singapore Private Limited",
  ],
  CORPORATE_INSURANCE_DEPARTMENT: [
    "HR Department",

    "Thomson Specialists (Paragon)",

    "Facilities Management",

    "Operating Theatre",

    "Nursing Admin",

    "Marketing & Communications ",

    "TPC 4",

    "Human Resource",

    "6th Storey",

    "Customer Experience Office",

    "Environmental Health & Safety",

    "Singapore Management Office",

    "Thomson Specialists (Woodleigh)",

    "Business Office",

    "Digital and Information Technology",

    "Group Management Office",

    "Finance",

    "TPC Bukit Panjang",

    "Central Supplies",

    "TPC Katong",

    "Premier Suite",

    "24-Hour Urgent Care Centre",

    "4th Storey",

    "TIC",

    "TDIC",

    "Car Park",

    "Delivery Suite",

    "Day Surgery",

    "Pharmacy",

    "Thomson Specialists (TMC)",

    "TDUC",

    "NICU",

    "Premier Ward",

    "TFC",

    "TDC",

    "3rd Storey",

    "Medical Records Office",

    "PCCC (Inpatient)",

    "PCCC (Outpatient)",

    "PCC_Product",

    "TPC 1",

    "TPC Punggol",

    "TPC Jurong",

    "TWC_Serangoon Central",

    "TCM Paragon",

    "TCM Waterway Point",

    "TCM United Square",

    "TSSC",

    "Doctors Engagement",

    "Business Development",

    "Biomedical Engineering",

    "Quality and Risk Management",

    "TPDL",

    "Operations Management",

    "Thomson Life - TCM  (Woodleigh)",

    "CSSU",

    "Thomson X",

    "Thomson Specialists (Paragon) - MHS",

    "Medical Affairs",

    "TFC United Square",

    "Thomson OncoCare Cancer Centre",

    "TWC_Katong",

    "TWC_Choa Chu Kang",

    "Thomson Women's Clinic & Cancer Surgery",
  ],
  NOK_RELATIONSHIP: [
    { value: "REL001", label: "Spouse" },
    { value: "REL002", label: "Parent" },
    { value: "REL003", label: "Grandparent" },
    { value: "REL004", label: "Children" },
    { value: "REL005", label: "In-Laws" },
    { value: "REL006", label: "Siblings" },
    { value: "REL007", label: "Grandchildren" },
    { value: "REL008", label: "Ward" },
    { value: "REL009", label: "Guardian" },
    { value: "REL010", label: "Other Family Member" },
    { value: "REL011", label: "Other Non-Family Member" },
    { value: "REL999", label: "Data Not Available" },
    { value: "REL101", label: "Husband" },
    { value: "REL102", label: "Wife" },
    { value: "REL201", label: "Mother" },
    { value: "REL202", label: "Father" },
    { value: "REL203", label: "Adoptive Father" },
    { value: "REL204", label: "Adoptive Mother" },
    { value: "REL205", label: "Step-Father" },
    { value: "REL206", label: "Step-Mother" },
    { value: "REL207", label: "Foster Father" },
    { value: "REL208", label: "Foster Mother" },
    { value: "REL301", label: "Grandfather" },
    { value: "REL302", label: "Grandmother" },
    { value: "REL401", label: "Son" },
    { value: "REL402", label: "Daughter" },
    { value: "REL403", label: "Adopted Son" },
    { value: "REL404", label: "Adopted Daughter" },
    { value: "REL405", label: "Step-Son" },
    { value: "REL406", label: "Step-Daughter" },
    { value: "REL407", label: "Foster Child" },
    { value: "REL501", label: "Father In-Laws" },
    { value: "REL502", label: "Mother In-Laws" },
    { value: "REL503", label: "Brother In-Laws" },
    { value: "REL504", label: "Sister In-Laws" },
    { value: "REL505", label: "Son In-Laws" },
    { value: "REL506", label: "Daughter In-Laws" },
    { value: "REL601", label: "Brother" },
    { value: "REL602", label: "Sister" },
    { value: "REL603", label: "Adopted Brother" },
    { value: "REL604", label: "Adopted Sister" },
    { value: "REL605", label: "Step-Brother" },
    { value: "REL606", label: "Step-Sister" },
    { value: "REL607", label: "Half-Brother" },
    { value: "REL608", label: "Half-Sister" },
    { value: "REL701", label: "Grandson" },
    { value: "REL702", label: "Granddaughter" },
    { value: "REL801", label: "Uncle" },
    { value: "REL802", label: "Aunt" },
    { value: "REL803", label: "Nephew" },
    { value: "REL804", label: "Niece" },
    { value: "REL805", label: "Cousin" },
    { value: "REL806", label: "Significant Other" },
  ],
  MEDISAVE_RELATIONSHIP: [
    { value: "REL001", label: "Spouse" },
    { value: "REL002", label: "Parent" },
    { value: "REL003", label: "Grandparent" },
    { value: "REL004", label: "Children" },
    { value: "REL005", label: "In-Laws" },
    { value: "REL006", label: "Siblings" },
    { value: "REL007", label: "Grandchildren" },
    { value: "REL008", label: "Ward" },
    { value: "REL009", label: "Guardian" },
    { value: "REL010", label: "Other Family Member" },
    { value: "REL011", label: "Other Non-Family Member" },
    { value: "REL999", label: "Data Not Available" },
    { value: "REL101", label: "Husband" },
    { value: "REL102", label: "Wife" },
    { value: "REL201", label: "Mother" },
    { value: "REL202", label: "Father" },
    { value: "REL203", label: "Adoptive Father" },
    { value: "REL204", label: "Adoptive Mother" },
    { value: "REL205", label: "Step-Father" },
    { value: "REL206", label: "Step-Mother" },
    { value: "REL207", label: "Foster Father" },
    { value: "REL208", label: "Foster Mother" },
    { value: "REL301", label: "Grandfather" },
    { value: "REL302", label: "Grandmother" },
    { value: "REL401", label: "Son" },
    { value: "REL402", label: "Daughter" },
    { value: "REL403", label: "Adopted Son" },
    { value: "REL404", label: "Adopted Daughter" },
    { value: "REL405", label: "Step-Son" },
    { value: "REL406", label: "Step-Daughter" },
    { value: "REL407", label: "Foster Child" },
    { value: "REL501", label: "Father In-Laws" },
    { value: "REL502", label: "Mother In-Laws" },
    { value: "REL503", label: "Brother In-Laws" },
    { value: "REL504", label: "Sister In-Laws" },
    { value: "REL505", label: "Son In-Laws" },
    { value: "REL506", label: "Daughter In-Laws" },
    { value: "REL601", label: "Brother" },
    { value: "REL602", label: "Sister" },
    { value: "REL603", label: "Adopted Brother" },
    { value: "REL604", label: "Adopted Sister" },
    { value: "REL605", label: "Step-Brother" },
    { value: "REL606", label: "Step-Sister" },
    { value: "REL607", label: "Half-Brother" },
    { value: "REL608", label: "Half-Sister" },
    { value: "REL701", label: "Grandson" },
    { value: "REL702", label: "Granddaughter" },
    { value: "REL801", label: "Uncle" },
    { value: "REL802", label: "Aunt" },
    { value: "REL803", label: "Nephew" },
    { value: "REL804", label: "Niece" },
    { value: "REL805", label: "Cousin" },
    { value: "REL806", label: "Significant Other" },
    { value: "Self", label: "Self" },
  ],
  MOBILE_COUNTRY_CODE: [
    {
      id: 186,
      nationality: "Singaporean",
      country: "Singapore",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sg.svg",
      dialCode: "+65",
      code: "SG",
    },
    {
      id: 127,
      nationality: "Malaysian",
      country: "Malaysia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/my.svg",
      dialCode: "+60",
      code: "MY",
    },
    {
      id: 99,
      nationality: "Indonesian",
      country: "Indonesia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/id.svg",
      dialCode: "+62",
      code: "ID",
    },
    {
      id: 232,
      nationality: "Vietnamese",
      country: "Vietnam",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/vn.svg",
      dialCode: "+84",
      code: "VN",
    },
    {
      id: 44,
      nationality: "Chinese",
      country: "China",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cn.svg",
      dialCode: "+86",
      code: "CN",
    },
    {
      id: 1,
      nationality: "Afghan",
      country: "Afghanistan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/af.svg",
      dialCode: "+93",
      code: "AF",
    },
    {
      id: 237,
      nationality: "Åland Island",
      country: "Åland Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ax.svg",
      dialCode: "+358",
      code: "AX",
    },
    {
      id: 2,
      nationality: "Albanian",
      country: "Albania",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/al.svg",
      dialCode: "+355",
      code: "AL",
    },
    {
      id: 3,
      nationality: "Algerian",
      country: "Algeria",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/dz.svg",
      dialCode: "+213",
      code: "DZ",
    },
    {
      id: 4,
      nationality: "American Samoan",
      country: "American Samoa",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/as.svg",
      dialCode: "+1684",
      code: "AS",
    },
    {
      id: 5,
      nationality: "Andorran",
      country: "Andorra",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ad.svg",
      dialCode: "+376",
      code: "AD",
    },
    {
      id: 6,
      nationality: "Angolan",
      country: "Angola",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ao.svg",
      dialCode: "+244",
      code: "AO",
    },
    {
      id: 7,
      nationality: "Anguillan",
      country: "Anguilla",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ai.svg",
      dialCode: "+1264",
      code: "AI",
    },
    {
      id: 8,
      nationality: "Antarctic",
      country: "Antarctica",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/aq.svg",
      dialCode: "+672",
      code: "AQ",
    },
    {
      id: 9,
      nationality: "Antiguan or Barbudan",
      country: "Antigua & Barbuda",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ag.svg",
      dialCode: "+1268",
      code: "AG",
    },
    {
      id: 10,
      nationality: "Argentine",
      country: "Argentina",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ar.svg",
      dialCode: "+54",
      code: "AR",
    },
    {
      id: 11,
      nationality: "Armenian",
      country: "Armenia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/am.svg",
      dialCode: "+374",
      code: "AM",
    },
    {
      id: 12,
      nationality: "Aruban",
      country: "Aruba",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/aw.svg",
      dialCode: "+297",
      code: "AW",
    },
    {
      id: 13,
      nationality: "Australian",
      country: "Australia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/au.svg",
      dialCode: "+61",
      code: "AU",
    },
    {
      id: 14,
      nationality: "Austrian",
      country: "Austria",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/at.svg",
      dialCode: "+43",
      code: "AT",
    },
    {
      id: 15,
      nationality: "Azerbaijani, Azeri",
      country: "Azerbaijan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/az.svg",
      dialCode: "+994",
      code: "AZ",
    },
    {
      id: 16,
      nationality: "Bahamian",
      country: "Bahamas",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bs.svg",
      dialCode: "+1242",
      code: "BS",
    },
    {
      id: 17,
      nationality: "Bahraini",
      country: "Bahrain",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bh.svg",
      dialCode: "+973",
      code: "BH",
    },
    {
      id: 18,
      nationality: "Bangladeshi",
      country: "Bangladesh",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bd.svg",
      dialCode: "+880",
      code: "BD",
    },
    {
      id: 19,
      nationality: "Barbadian",
      country: "Barbados",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bb.svg",
      dialCode: "+1246",
      code: "BB",
    },
    {
      id: 20,
      nationality: "Belarusian",
      country: "Belarus",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/by.svg",
      dialCode: "+375",
      code: "BY",
    },
    {
      id: 21,
      nationality: "Belgian",
      country: "Belgium",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/be.svg",
      dialCode: "+32",
      code: "BE",
    },
    {
      id: 22,
      nationality: "Belizean",
      country: "Belize",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bz.svg",
      dialCode: "+501",
      code: "BZ",
    },
    {
      id: 23,
      nationality: "Beninese, Beninois",
      country: "Benin",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bj.svg",
      dialCode: "+229",
      code: "BJ",
    },
    {
      id: 24,
      nationality: "Bermudian, Bermudan",
      country: "Bermuda",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bm.svg",
      dialCode: "+1441",
      code: "BM",
    },
    {
      id: 25,
      nationality: "Bhutanese",
      country: "Bhutan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bt.svg",
      dialCode: "+975",
      code: "BT",
    },
    {
      id: 26,
      nationality: "Bolivian",
      country: "Bolivia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bo.svg",
      dialCode: "+591",
      code: "BO",
    },
    {
      id: 27,
      nationality: "Bosnian or Herzegovinian",
      country: "Bosnia & Herzegovina",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ba.svg",
      dialCode: "+387",
      code: "BA",
    },
    {
      id: 28,
      nationality: "Motswana, Botswanan",
      country: "Botswana",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bw.svg",
      dialCode: "+267",
      code: "BW",
    },
    {
      id: 29,
      nationality: "Brazilian",
      country: "Brazil",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/br.svg",
      dialCode: "+55",
      code: "BR",
    },
    {
      id: 30,
      nationality: "BIOT",
      country: "British Indian Ocean Territory",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/io.svg",
      dialCode: "+246",
      code: "IO",
    },
    {
      id: 31,
      nationality: "British Virgin Island",
      country: "British Virgin Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/vg.svg",
      dialCode: "+1284",
      code: "VG",
    },
    {
      id: 32,
      nationality: "Bruneian",
      country: "Brunei",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bn.svg",
      dialCode: "+673",
      code: "BN",
    },
    {
      id: 33,
      nationality: "Bulgarian",
      country: "Bulgaria",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bg.svg",
      dialCode: "+359",
      code: "BG",
    },
    {
      id: 34,
      nationality: "Burkinabé",
      country: "Burkina Faso",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bf.svg",
      dialCode: "+226",
      code: "BF",
    },
    {
      id: 35,
      nationality: "Burundian",
      country: "Burundi",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bi.svg",
      dialCode: "+257",
      code: "BI",
    },
    {
      id: 36,
      nationality: "Cambodian",
      country: "Cambodia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/kh.svg",
      dialCode: "+855",
      code: "KH",
    },
    {
      id: 37,
      nationality: "Cameroonian",
      country: "Cameroon",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cm.svg",
      dialCode: "+237",
      code: "CM",
    },
    {
      id: 38,
      nationality: "Canadian",
      country: "Canada",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ca.svg",
      dialCode: "+1",
      code: "CA",
    },
    {
      id: 39,
      nationality: "Cabo Verdean",
      country: "Cape Verde",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cv.svg",
      dialCode: "+238",
      code: "CV",
    },
    {
      id: 40,
      nationality: "Caymanian",
      country: "Cayman Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ky.svg",
      dialCode: "+1345",
      code: "KY",
    },
    {
      id: 41,
      nationality: "Central African",
      country: "Central African Republic",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cf.svg",
      dialCode: "+236",
      code: "CF",
    },
    {
      id: 42,
      nationality: "Chadian",
      country: "Chad",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/td.svg",
      dialCode: "+235",
      code: "TD",
    },
    {
      id: 43,
      nationality: "Chilean",
      country: "Chile",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cl.svg",
      dialCode: "+56",
      code: "CL",
    },
    {
      id: 45,
      nationality: "Christmas Island",
      country: "Christmas Island",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cx.svg",
      dialCode: "+61",
      code: "CX",
    },
    {
      id: 46,
      nationality: "Cocos Island",
      country: "Cocos (Keeling) Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cc.svg",
      dialCode: "+61",
      code: "CC",
    },
    {
      id: 47,
      nationality: "Colombian",
      country: "Colombia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/co.svg",
      dialCode: "+57",
      code: "CO",
    },
    {
      id: 48,
      nationality: "Comoran, Comorian",
      country: "Comoros",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/km.svg",
      dialCode: "+269",
      code: "KM",
    },
    {
      id: 49,
      nationality: "Congolese - Brazzaville",
      country: "Congo - Brazzaville",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cg.svg",
      dialCode: "+242",
      code: "CG",
    },
    {
      id: 50,
      nationality: "Congolese - Kinshasa",
      country: "Congo - Kinshasa",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cd.svg",
      dialCode: "+243",
      code: "CD",
    },
    {
      id: 51,
      nationality: "Cook Island",
      country: "Cook Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ck.svg",
      dialCode: "+682",
      code: "CK",
    },
    {
      id: 52,
      nationality: "Costa Rican",
      country: "Costa Rica",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cr.svg",
      dialCode: "+506",
      code: "CR",
    },
    {
      id: 53,
      nationality: "Ivorian",
      country: "Côte d’Ivoire",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ci.svg",
      dialCode: "+225",
      code: "CI",
    },
    {
      id: 54,
      nationality: "Croatian",
      country: "Croatia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/hr.svg",
      dialCode: "+385",
      code: "HR",
    },
    {
      id: 55,
      nationality: "Cuban",
      country: "Cuba",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cu.svg",
      dialCode: "+53",
      code: "CU",
    },
    {
      id: 56,
      nationality: "Cypriot",
      country: "Cyprus",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cy.svg",
      dialCode: "+357",
      code: "CY",
    },
    {
      id: 57,
      nationality: "Czech",
      country: "Czechia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/cz.svg",
      dialCode: "+420",
      code: "CZ",
    },
    {
      id: 58,
      nationality: "Danish",
      country: "Denmark",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/dk.svg",
      dialCode: "+45",
      code: "DK",
    },
    {
      id: 59,
      nationality: "Djiboutian",
      country: "Djibouti",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/dj.svg",
      dialCode: "+253",
      code: "DJ",
    },
    {
      id: 60,
      nationality: "Dominican",
      country: "Dominica",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/dm.svg",
      dialCode: "+1767",
      code: "DM",
    },
    {
      id: 61,
      nationality: "Dominican",
      country: "Dominican Republic",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/do.svg",
      dialCode: "+1849",
      code: "DO",
    },
    {
      id: 62,
      nationality: "Ecuadorian",
      country: "Ecuador",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ec.svg",
      dialCode: "+593",
      code: "EC",
    },
    {
      id: 63,
      nationality: "Egyptian",
      country: "Egypt",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/eg.svg",
      dialCode: "+20",
      code: "EG",
    },
    {
      id: 64,
      nationality: "Salvadoran",
      country: "El Salvador",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sv.svg",
      dialCode: "+503",
      code: "SV",
    },
    {
      id: 65,
      nationality: "Equatorial Guinean, Equatoguinean",
      country: "Equatorial Guinea",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gq.svg",
      dialCode: "+240",
      code: "GQ",
    },
    {
      id: 66,
      nationality: "Eritrean",
      country: "Eritrea",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/er.svg",
      dialCode: "+291",
      code: "ER",
    },
    {
      id: 67,
      nationality: "Estonian",
      country: "Estonia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ee.svg",
      dialCode: "+372",
      code: "EE",
    },
    {
      id: 68,
      nationality: "Swazi",
      country: "Eswatini",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sz.svg",
      dialCode: "+268",
      code: "SZ",
    },
    {
      id: 69,
      nationality: "Ethiopian",
      country: "Ethiopia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/et.svg",
      dialCode: "+251",
      code: "ET",
    },
    {
      id: 70,
      nationality: "Falkland Island",
      country: "Falkland Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/fk.svg",
      dialCode: "+500",
      code: "FK",
    },
    {
      id: 71,
      nationality: "Faroese",
      country: "Faroe Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/fo.svg",
      dialCode: "+298",
      code: "FO",
    },
    {
      id: 72,
      nationality: "Fijian",
      country: "Fiji",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/fj.svg",
      dialCode: "+679",
      code: "FJ",
    },
    {
      id: 73,
      nationality: "Finnish",
      country: "Finland",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/fi.svg",
      dialCode: "+358",
      code: "FI",
    },
    {
      id: 74,
      nationality: "French",
      country: "France",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/fr.svg",
      dialCode: "+33",
      code: "FR",
    },
    {
      id: 75,
      nationality: "French Guianese",
      country: "French Guiana",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gf.svg",
      dialCode: "+594",
      code: "GF",
    },
    {
      id: 76,
      nationality: "French Polynesian",
      country: "French Polynesia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pf.svg",
      dialCode: "+689",
      code: "PF",
    },
    {
      id: 77,
      nationality: "Gabonese",
      country: "Gabon",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ga.svg",
      dialCode: "+241",
      code: "GA",
    },
    {
      id: 78,
      nationality: "Gambian",
      country: "Gambia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gm.svg",
      dialCode: "+220",
      code: "GM",
    },
    {
      id: 79,
      nationality: "Georgian",
      country: "Georgia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ge.svg",
      dialCode: "+995",
      code: "GE",
    },
    {
      id: 80,
      nationality: "German",
      country: "Germany",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/de.svg",
      dialCode: "+49",
      code: "DE",
    },
    {
      id: 81,
      nationality: "Ghanaian",
      country: "Ghana",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gh.svg",
      dialCode: "+233",
      code: "GH",
    },
    {
      id: 82,
      nationality: "Gibraltar",
      country: "Gibraltar",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gi.svg",
      dialCode: "+350",
      code: "GI",
    },
    {
      id: 83,
      nationality: "Greek, Hellenic",
      country: "Greece",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gr.svg",
      dialCode: "+30",
      code: "GR",
    },
    {
      id: 84,
      nationality: "Greenlandic",
      country: "Greenland",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gl.svg",
      dialCode: "+299",
      code: "GL",
    },
    {
      id: 85,
      nationality: "Grenadian",
      country: "Grenada",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gd.svg",
      dialCode: "+1473",
      code: "GD",
    },
    {
      id: 86,
      nationality: "Guadeloupe",
      country: "Guadeloupe",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gp.svg",
      dialCode: "+590",
      code: "GP",
    },
    {
      id: 87,
      nationality: "Guamanian, Guambat",
      country: "Guam",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gu.svg",
      dialCode: "+1671",
      code: "GU",
    },
    {
      id: 88,
      nationality: "Guatemalan",
      country: "Guatemala",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gt.svg",
      dialCode: "+502",
      code: "GT",
    },
    {
      id: 89,
      nationality: "Channel Island",
      country: "Guernsey",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gg.svg",
      dialCode: "+44-1481",
      code: "GG",
    },
    {
      id: 90,
      nationality: "Guinean",
      country: "Guinea",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gn.svg",
      dialCode: "+224",
      code: "GN",
    },
    {
      id: 91,
      nationality: "Bissau-Guinean",
      country: "Guinea-Bissau",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gw.svg",
      dialCode: "+245",
      code: "GW",
    },
    {
      id: 92,
      nationality: "Guyanese",
      country: "Guyana",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gy.svg",
      dialCode: "+592",
      code: "GY",
    },
    {
      id: 93,
      nationality: "Haitian",
      country: "Haiti",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ht.svg",
      dialCode: "+509",
      code: "HT",
    },
    {
      id: 94,
      nationality: "Honduran",
      country: "Honduras",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/hn.svg",
      dialCode: "+504",
      code: "HN",
    },
    {
      id: 95,
      nationality: "Hong Kong, Hong Kongese",
      country: "Hong Kong SAR China",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/hk.svg",
      dialCode: "+852",
      code: "HK",
    },
    {
      id: 96,
      nationality: "Hungarian, Magyar",
      country: "Hungary",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/hu.svg",
      dialCode: "+36",
      code: "HU",
    },
    {
      id: 97,
      nationality: "Icelandic",
      country: "Iceland",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/is.svg",
      dialCode: "+354",
      code: "IS",
    },
    {
      id: 98,
      nationality: "Indian",
      country: "India",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/in.svg",
      dialCode: "+91",
      code: "IN",
    },
    {
      id: 100,
      nationality: "Iranian, Persian",
      country: "Iran",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ir.svg",
      dialCode: "+98",
      code: "IR",
    },
    {
      id: 101,
      nationality: "Iraqi",
      country: "Iraq",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/iq.svg",
      dialCode: "+964",
      code: "IQ",
    },
    {
      id: 102,
      nationality: "Irish",
      country: "Ireland",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ie.svg",
      dialCode: "+353",
      code: "IE",
    },
    {
      id: 103,
      nationality: "Manx",
      country: "Isle of Man",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/im.svg",
      dialCode: "+44-1624",
      code: "IM",
    },
    {
      id: 104,
      nationality: "Israeli",
      country: "Israel",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/il.svg",
      dialCode: "+972",
      code: "IL",
    },
    {
      id: 105,
      nationality: "Italian",
      country: "Italy",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/it.svg",
      dialCode: "+39",
      code: "IT",
    },
    {
      id: 106,
      nationality: "Jamaican",
      country: "Jamaica",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/jm.svg",
      dialCode: "+1876",
      code: "JM",
    },
    {
      id: 107,
      nationality: "Japanese",
      country: "Japan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/jp.svg",
      dialCode: "+81",
      code: "JP",
    },
    {
      id: 108,
      nationality: "Channel Island",
      country: "Jersey",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/je.svg",
      dialCode: "+44-1534",
      code: "JE",
    },
    {
      id: 109,
      nationality: "Jordanian",
      country: "Jordan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/jo.svg",
      dialCode: "+962",
      code: "JO",
    },
    {
      id: 110,
      nationality: "Kazakhstani, Kazakh",
      country: "Kazakhstan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/kz.svg",
      dialCode: "+77",
      code: "KZ",
    },
    {
      id: 111,
      nationality: "Kenyan",
      country: "Kenya",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ke.svg",
      dialCode: "+254",
      code: "KE",
    },
    {
      id: 112,
      nationality: "I-Kiribati",
      country: "Kiribati",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ki.svg",
      dialCode: "+686",
      code: "KI",
    },
    {
      id: 113,
      nationality: "Kuwaiti",
      country: "Kuwait",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/kw.svg",
      dialCode: "+965",
      code: "KW",
    },
    {
      id: 114,
      nationality: "Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz",
      country: "Kyrgyzstan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/kg.svg",
      dialCode: "+996",
      code: "KG",
    },
    {
      id: 115,
      nationality: "Lao, Laotian",
      country: "Laos",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/la.svg",
      dialCode: "+856",
      code: "LA",
    },
    {
      id: 116,
      nationality: "Latvian",
      country: "Latvia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/lv.svg",
      dialCode: "+371",
      code: "LV",
    },
    {
      id: 117,
      nationality: "Lebanese",
      country: "Lebanon",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/lb.svg",
      dialCode: "+961",
      code: "LB",
    },
    {
      id: 118,
      nationality: "Basotho",
      country: "Lesotho",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ls.svg",
      dialCode: "+266",
      code: "LS",
    },
    {
      id: 119,
      nationality: "Liberian",
      country: "Liberia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/lr.svg",
      dialCode: "+231",
      code: "LR",
    },
    {
      id: 120,
      nationality: "Libyan",
      country: "Libya",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ly.svg",
      dialCode: "+218",
      code: "LY",
    },
    {
      id: 121,
      nationality: "Liechtenstein",
      country: "Liechtenstein",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/li.svg",
      dialCode: "+423",
      code: "LI",
    },
    {
      id: 122,
      nationality: "Lithuanian",
      country: "Lithuania",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/lt.svg",
      dialCode: "+370",
      code: "LT",
    },
    {
      id: 123,
      nationality: "Luxembourg, Luxembourgish",
      country: "Luxembourg",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/lu.svg",
      dialCode: "+352",
      code: "LU",
    },
    {
      id: 124,
      nationality: "Macanese, Chinese",
      country: "Macao SAR China",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mo.svg",
      dialCode: "+853",
      code: "MO",
    },
    {
      id: 125,
      nationality: "Malagasy",
      country: "Madagascar",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mg.svg",
      dialCode: "+261",
      code: "MG",
    },
    {
      id: 126,
      nationality: "Malawian",
      country: "Malawi",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mw.svg",
      dialCode: "+265",
      code: "MW",
    },
    {
      id: 128,
      nationality: "Maldivian",
      country: "Maldives",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mv.svg",
      dialCode: "+960",
      code: "MV",
    },
    {
      id: 129,
      nationality: "Malian, Malinese",
      country: "Mali",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ml.svg",
      dialCode: "+223",
      code: "ML",
    },
    {
      id: 130,
      nationality: "Maltese",
      country: "Malta",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mt.svg",
      dialCode: "+356",
      code: "MT",
    },
    {
      id: 131,
      nationality: "Marshallese",
      country: "Marshall Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mh.svg",
      dialCode: "+692",
      code: "MH",
    },
    {
      id: 132,
      nationality: "Martiniquais, Martinican",
      country: "Martinique",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mq.svg",
      dialCode: "+596",
      code: "MQ",
    },
    {
      id: 133,
      nationality: "Mauritanian",
      country: "Mauritania",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mr.svg",
      dialCode: "+222",
      code: "MR",
    },
    {
      id: 134,
      nationality: "Mauritian",
      country: "Mauritius",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mu.svg",
      dialCode: "+230",
      code: "MU",
    },
    {
      id: 135,
      nationality: "Mahoran",
      country: "Mayotte",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/yt.svg",
      dialCode: "+262",
      code: "YT",
    },
    {
      id: 136,
      nationality: "Mexican",
      country: "Mexico",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mx.svg",
      dialCode: "+52",
      code: "MX",
    },
    {
      id: 137,
      nationality: "Micronesian",
      country: "Micronesia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/fm.svg",
      dialCode: "+691",
      code: "FM",
    },
    {
      id: 138,
      nationality: "Moldovan",
      country: "Moldova",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/md.svg",
      dialCode: "+373",
      code: "MD",
    },
    {
      id: 139,
      nationality: "Monégasque, Monacan",
      country: "Monaco",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mc.svg",
      dialCode: "+377",
      code: "MC",
    },
    {
      id: 140,
      nationality: "Mongolian",
      country: "Mongolia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mn.svg",
      dialCode: "+976",
      code: "MN",
    },
    {
      id: 141,
      nationality: "Montenegrin",
      country: "Montenegro",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/me.svg",
      dialCode: "+382",
      code: "ME",
    },
    {
      id: 142,
      nationality: "Montserratian",
      country: "Montserrat",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ms.svg",
      dialCode: "+1664",
      code: "MS",
    },
    {
      id: 143,
      nationality: "Moroccan",
      country: "Morocco",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ma.svg",
      dialCode: "+212",
      code: "MA",
    },
    {
      id: 144,
      nationality: "Mozambican",
      country: "Mozambique",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mz.svg",
      dialCode: "+258",
      code: "MZ",
    },
    {
      id: 145,
      nationality: "Burmese",
      country: "Myanmar (Burma)",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mm.svg",
      dialCode: "+95",
      code: "MM",
    },
    {
      id: 146,
      nationality: "Namibian",
      country: "Namibia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/na.svg",
      dialCode: "+264",
      code: "NA",
    },
    {
      id: 147,
      nationality: "Nauruan",
      country: "Nauru",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/nr.svg",
      dialCode: "+674",
      code: "NR",
    },
    {
      id: 148,
      nationality: "Nepali, Nepalese",
      country: "Nepal",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/np.svg",
      dialCode: "+977",
      code: "NP",
    },
    {
      id: 149,
      nationality: "Dutch, Netherlandic",
      country: "Netherlands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/nl.svg",
      dialCode: "+31",
      code: "NL",
    },
    {
      id: 150,
      nationality: "New Caledonian",
      country: "New Caledonia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/nc.svg",
      dialCode: "+687",
      code: "NC",
    },
    {
      id: 151,
      nationality: "New Zealand, NZ",
      country: "New Zealand",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/nz.svg",
      dialCode: "+64",
      code: "NZ",
    },
    {
      id: 152,
      nationality: "Nicaraguan",
      country: "Nicaragua",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ni.svg",
      dialCode: "+505",
      code: "NI",
    },
    {
      id: 153,
      nationality: "Nigerien",
      country: "Niger",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ne.svg",
      dialCode: "+227",
      code: "NE",
    },
    {
      id: 154,
      nationality: "Nigerian",
      country: "Nigeria",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ng.svg",
      dialCode: "+234",
      code: "NG",
    },
    {
      id: 155,
      nationality: "Niuean",
      country: "Niue",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/nu.svg",
      dialCode: "+683",
      code: "NU",
    },
    {
      id: 156,
      nationality: "Norfolk Island",
      country: "Norfolk Island",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/nf.svg",
      dialCode: "+672",
      code: "NF",
    },
    {
      id: 157,
      nationality: "North Korean",
      country: "North Korea",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/kp.svg",
      dialCode: "+850",
      code: "KP",
    },
    {
      id: 158,
      nationality: "Macedonian",
      country: "North Macedonia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mk.svg",
      dialCode: "+389",
      code: "MK",
    },
    {
      id: 238,
      nationality: "Northern Marianan",
      country: "Northern Mariana Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mp.svg",
      dialCode: "+1670",
      code: "MP",
    },
    {
      id: 159,
      nationality: "Norwegian",
      country: "Norway",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/no.svg",
      dialCode: "+47",
      code: "NO",
    },
    {
      id: 160,
      nationality: "Omani",
      country: "Oman",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/om.svg",
      dialCode: "+968",
      code: "OM",
    },
    {
      id: 161,
      nationality: "Pakistani",
      country: "Pakistan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pk.svg",
      dialCode: "+92",
      code: "PK",
    },
    {
      id: 162,
      nationality: "Palauan",
      country: "Palau",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pw.svg",
      dialCode: "+680",
      code: "PW",
    },
    {
      id: 163,
      nationality: "Palestinian",
      country: "Palestinian Territories",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ps.svg",
      dialCode: "+970",
      code: "PS",
    },
    {
      id: 164,
      nationality: "Panamanian",
      country: "Panama",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pa.svg",
      dialCode: "+507",
      code: "PA",
    },
    {
      id: 165,
      nationality: "Papua New Guinean, Papuan",
      country: "Papua New Guinea",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pg.svg",
      dialCode: "+675",
      code: "PG",
    },
    {
      id: 166,
      nationality: "Paraguayan",
      country: "Paraguay",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/py.svg",
      dialCode: "+595",
      code: "PY",
    },
    {
      id: 167,
      nationality: "Peruvian",
      country: "Peru",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pe.svg",
      dialCode: "+51",
      code: "PE",
    },
    {
      id: 168,
      nationality: "Philippine, Filipino",
      country: "Philippines",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ph.svg",
      dialCode: "+63",
      code: "PH",
    },
    {
      id: 169,
      nationality: "Pitcairn Island",
      country: "Pitcairn Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pn.svg",
      dialCode: "+872",
      code: "PN",
    },
    {
      id: 170,
      nationality: "Polish",
      country: "Poland",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pl.svg",
      dialCode: "+48",
      code: "PL",
    },
    {
      id: 171,
      nationality: "Portuguese",
      country: "Portugal",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pt.svg",
      dialCode: "+351",
      code: "PT",
    },
    {
      id: 172,
      nationality: "Puerto Rican",
      country: "Puerto Rico",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pr.svg",
      dialCode: "+1939",
      code: "PR",
    },
    {
      id: 173,
      nationality: "Qatari",
      country: "Qatar",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/qa.svg",
      dialCode: "+974",
      code: "QA",
    },
    {
      id: 174,
      nationality: "Réunionese, Réunionnais",
      country: "Réunion",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/re.svg",
      dialCode: "+262",
      code: "RE",
    },
    {
      id: 175,
      nationality: "Romanian",
      country: "Romania",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ro.svg",
      dialCode: "+40",
      code: "RO",
    },
    {
      id: 176,
      nationality: "Russian",
      country: "Russia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ru.svg",
      dialCode: "+7",
      code: "RU",
    },
    {
      id: 177,
      nationality: "Rwandan",
      country: "Rwanda",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/rw.svg",
      dialCode: "+250",
      code: "RW",
    },
    {
      id: 178,
      nationality: "Samoan",
      country: "Samoa",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ws.svg",
      dialCode: "+685",
      code: "WS",
    },
    {
      id: 179,
      nationality: "Sammarinese",
      country: "San Marino",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sm.svg",
      dialCode: "+378",
      code: "SM",
    },
    {
      id: 180,
      nationality: "São Toméan",
      country: "São Tomé & Príncipe",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/st.svg",
      dialCode: "+239",
      code: "ST",
    },
    {
      id: 181,
      nationality: "Saudi, Saudi Arabian",
      country: "Saudi Arabia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sa.svg",
      dialCode: "+966",
      code: "SA",
    },
    {
      id: 182,
      nationality: "Senegalese",
      country: "Senegal",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sn.svg",
      dialCode: "+221",
      code: "SN",
    },
    {
      id: 183,
      nationality: "Serbian",
      country: "Serbia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/rs.svg",
      dialCode: "+381",
      code: "RS",
    },
    {
      id: 184,
      nationality: "Seychellois",
      country: "Seychelles",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sc.svg",
      dialCode: "+248",
      code: "SC",
    },
    {
      id: 185,
      nationality: "Sierra Leonean",
      country: "Sierra Leone",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sl.svg",
      dialCode: "+232",
      code: "SL",
    },
    {
      id: 187,
      nationality: "Slovak",
      country: "Slovakia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sk.svg",
      dialCode: "+421",
      code: "SK",
    },
    {
      id: 188,
      nationality: "Slovenian, Slovene",
      country: "Slovenia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/si.svg",
      dialCode: "+386",
      code: "SI",
    },
    {
      id: 189,
      nationality: "Solomon Island",
      country: "Solomon Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sb.svg",
      dialCode: "+677",
      code: "SB",
    },
    {
      id: 190,
      nationality: "Somali, Somalian",
      country: "Somalia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/so.svg",
      dialCode: "+252",
      code: "SO",
    },
    {
      id: 191,
      nationality: "South African",
      country: "South Africa",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/za.svg",
      dialCode: "+27",
      code: "ZA",
    },
    {
      id: 239,
      nationality: "South Georgia or South Sandwich Islands",
      country: "South Georgia & South Sandwich Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gs.svg",
      dialCode: "+500",
      code: "GS",
    },
    {
      id: 192,
      nationality: "South Korean",
      country: "South Korea",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/kr.svg",
      dialCode: "+82",
      code: "KR",
    },
    {
      id: 240,
      nationality: "South Sudanese",
      country: "South Sudan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ss.svg",
      dialCode: "+211",
      code: "SS",
    },
    {
      id: 193,
      nationality: "Spanish",
      country: "Spain",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/es.svg",
      dialCode: "+34",
      code: "ES",
    },
    {
      id: 194,
      nationality: "Sri Lankan",
      country: "Sri Lanka",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/lk.svg",
      dialCode: "+94",
      code: "LK",
    },
    {
      id: 195,
      nationality: "Barthélemois",
      country: "St. Barthélemy",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/bl.svg",
      dialCode: "+590",
      code: "BL",
    },
    {
      id: 196,
      nationality: "Saint Helenian",
      country: "St. Helena",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sh.svg",
      dialCode: "+290",
      code: "SH",
    },
    {
      id: 197,
      nationality: "Kittitian or Nevisian",
      country: "St. Kitts & Nevis",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/kn.svg",
      dialCode: "+1869",
      code: "KN",
    },
    {
      id: 198,
      nationality: "Saint Lucian",
      country: "St. Lucia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/lc.svg",
      dialCode: "+1758",
      code: "LC",
    },
    {
      id: 199,
      nationality: "Saint-Martinoise",
      country: "St. Martin",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/mf.svg",
      dialCode: "+590",
      code: "MF",
    },
    {
      id: 200,
      nationality: "Saint-Pierrais or Miquelonnais",
      country: "St. Pierre & Miquelon",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/pm.svg",
      dialCode: "+508",
      code: "PM",
    },
    {
      id: 201,
      nationality: "Saint Vincentian, Vincentian",
      country: "St. Vincent & Grenadines",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/vc.svg",
      dialCode: "+1784",
      code: "VC",
    },
    {
      id: 202,
      nationality: "Sudanese",
      country: "Sudan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sd.svg",
      dialCode: "+249",
      code: "SD",
    },
    {
      id: 203,
      nationality: "Surinamese",
      country: "Suriname",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sr.svg",
      dialCode: "+597",
      code: "SR",
    },
    {
      id: 241,
      nationality: "Svalbard",
      country: "Svalbard & Jan Mayen",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sj.svg",
      dialCode: "+47",
      code: "SJ",
    },
    {
      id: 204,
      nationality: "Swedish",
      country: "Sweden",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/se.svg",
      dialCode: "+46",
      code: "SE",
    },
    {
      id: 205,
      nationality: "Swiss",
      country: "Switzerland",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ch.svg",
      dialCode: "+41",
      code: "CH",
    },
    {
      id: 206,
      nationality: "Syrian",
      country: "Syria",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/sy.svg",
      dialCode: "+963",
      code: "SY",
    },
    {
      id: 207,
      nationality: "Chinese, Taiwanese",
      country: "Taiwan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tw.svg",
      dialCode: "+886",
      code: "TW",
    },
    {
      id: 208,
      nationality: "Tajikistani",
      country: "Tajikistan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tj.svg",
      dialCode: "+992",
      code: "TJ",
    },
    {
      id: 209,
      nationality: "Tanzanian",
      country: "Tanzania",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tz.svg",
      dialCode: "+255",
      code: "TZ",
    },
    {
      id: 210,
      nationality: "Thai",
      country: "Thailand",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/th.svg",
      dialCode: "+66",
      code: "TH",
    },
    {
      id: 211,
      nationality: "Timorese",
      country: "Timor-Leste",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tl.svg",
      dialCode: "+670",
      code: "TL",
    },
    {
      id: 212,
      nationality: "Togolese",
      country: "Togo",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tg.svg",
      dialCode: "+228",
      code: "TG",
    },
    {
      id: 213,
      nationality: "Tokelauan",
      country: "Tokelau",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tk.svg",
      dialCode: "+690",
      code: "TK",
    },
    {
      id: 214,
      nationality: "Tongan",
      country: "Tonga",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/to.svg",
      dialCode: "+676",
      code: "TO",
    },
    {
      id: 215,
      nationality: "Trinidadian or Tobagonian",
      country: "Trinidad & Tobago",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tt.svg",
      dialCode: "+1868",
      code: "TT",
    },
    {
      id: 216,
      nationality: "Tunisian",
      country: "Tunisia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tn.svg",
      dialCode: "+216",
      code: "TN",
    },
    {
      id: 217,
      nationality: "Turkish",
      country: "Turkey",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tr.svg",
      dialCode: "+90",
      code: "TR",
    },
    {
      id: 218,
      nationality: "Turkmen",
      country: "Turkmenistan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tm.svg",
      dialCode: "+993",
      code: "TM",
    },
    {
      id: 219,
      nationality: "Turks and Caicos Island",
      country: "Turks & Caicos Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tc.svg",
      dialCode: "+1649",
      code: "TC",
    },
    {
      id: 220,
      nationality: "Tuvaluan",
      country: "Tuvalu",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/tv.svg",
      dialCode: "+688",
      code: "TV",
    },
    {
      id: 221,
      nationality: "U.S. Virgin Island",
      country: "U.S. Virgin Islands",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/vi.svg",
      dialCode: "+1340",
      code: "VI",
    },
    {
      id: 222,
      nationality: "Ugandan",
      country: "Uganda",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ug.svg",
      dialCode: "+256",
      code: "UG",
    },
    {
      id: 223,
      nationality: "Ukrainian",
      country: "Ukraine",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ua.svg",
      dialCode: "+380",
      code: "UA",
    },
    {
      id: 224,
      nationality: "Emirati, Emirian, Emiri",
      country: "United Arab Emirates",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ae.svg",
      dialCode: "+971",
      code: "AE",
    },
    {
      id: 225,
      nationality: "British, UK",
      country: "United Kingdom",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/gb.svg",
      dialCode: "+44",
      code: "GB",
    },
    {
      id: 226,
      nationality: "American",
      country: "United States",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/us.svg",
      dialCode: "+1",
      code: "US",
    },
    {
      id: 227,
      nationality: "Uruguayan",
      country: "Uruguay",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/uy.svg",
      dialCode: "+598",
      code: "UY",
    },
    {
      id: 228,
      nationality: "Uzbekistani, Uzbek",
      country: "Uzbekistan",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/uz.svg",
      dialCode: "+998",
      code: "UZ",
    },
    {
      id: 229,
      nationality: "Ni-Vanuatu, Vanuatuan",
      country: "Vanuatu",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/vu.svg",
      dialCode: "+678",
      code: "VU",
    },
    {
      id: 230,
      nationality: "Vatican",
      country: "Vatican City",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/va.svg",
      dialCode: "+379",
      code: "VA",
    },
    {
      id: 231,
      nationality: "Venezuelan",
      country: "Venezuela",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ve.svg",
      dialCode: "+58",
      code: "VE",
    },
    {
      id: 233,
      nationality: "Wallis and Futuna, Wallisian or Futunan",
      country: "Wallis & Futuna",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/wf.svg",
      dialCode: "+681",
      code: "WF",
    },
    {
      id: 234,
      nationality: "Yemeni",
      country: "Yemen",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/ye.svg",
      dialCode: "+967",
      code: "YE",
    },
    {
      id: 235,
      nationality: "Zambian",
      country: "Zambia",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/zm.svg",
      dialCode: "+260",
      code: "ZM",
    },
    {
      id: 236,
      nationality: "Zimbabwean",
      country: "Zimbabwe",
      flagUrl: "https://hms-nation-flags.s3.ap-southeast-1.amazonaws.com/zw.svg",
      dialCode: "+263",
      code: "ZW",
    },
  ],
  ALLERGY_REACTION: [
    { label: "Rashes", value: "Rashes" },
    { label: "Drowsiness", value: "Drowsiness" },
    {
      label: "Acute Generalized Exanthematous Pustulosis",
      value: "Acute Generalized Exanthematous Pustulosis",
    },
    { label: "Erythema Multiforme", value: "Erythema Multiforme" },
    { label: "Erythema Nodosum", value: "Erythema Nodosum" },
    { label: "Erythroderma", value: "Erythroderma" },
    { label: "Face Oedema", value: "Face Oedema" },
    { label: "Fever", value: "Fever" },
    { label: "Fixed Drug Eruption", value: "Fixed Drug Eruption" },
    { label: "Flushing", value: "Flushing" },
    { label: "Giddiness", value: "Giddiness" },
    { label: "Hepatitis", value: "Hepatitis" },
    { label: "Hepatitis Cholestatic", value: "Hepatitis Cholestatic" },
    { label: "Agranulocytosis", value: "Agranulocytosis" },
    { label: "Hypotension", value: "Hypotension" },
    { label: "Jaundice", value: "Jaundice" },
    { label: "Laryngeal Oedema", value: "Laryngeal Oedema" },
    { label: "Leucocytoclastic Vasculitis", value: "Leucocytoclastic Vasculitis" },
    { label: "Leucopenia", value: "Leucopenia" },
    { label: "Erythroderma", value: "Erythroderma" },
    { label: "Lips Swelling Non-Specific", value: "Lips Swelling Non-Specific" },
    { label: "Liver Function Tests Abnormal", value: "Liver Function Tests Abnormal" },
    { label: "Mucosal Ulceration", value: "Mucosal Ulceration" },
    { label: "Nausea And/Or Vomiting (Severe)", value: "Nausea And/Or Vomiting (Severe)" },
    { label: "Neuroleptic Malignant Syndrome", value: "Neuroleptic Malignant Syndrome" },
    { label: "Anaemia Aplastic", value: "Anaemia Aplastic" },
    { label: "Oculogyric Crisis", value: "Oculogyric Crisis" },
    { label: "Oedema Periorbital", value: "Oedema Periorbital" },
    { label: "Oral Ulceration", value: "Oral Ulceration" },
    { label: "Pancytopenia", value: "Pancytopenia" },
    { label: "Pruritus", value: "Pruritus" },
    { label: "Rash", value: "Rash" },
    { label: "Rash Erythematous", value: "Rash Erythematous" },
    { label: "Rash Maculo-Papular", value: "Rash Maculo-Papular" },
    { label: "Stevens Johnson Syndrome", value: "Stevens Johnson Syndrome" },
    { label: "Stridor", value: "Stridor" },
    { label: "Thrombocytopenia", value: "Thrombocytopenia" },
    { label: "Tongue Swelling Non-Specific", value: "Tongue Swelling Non-Specific" },
    { label: "Toxic Epidermal Necrolysis", value: "Toxic Epidermal Necrolysis" },
    { label: "Urticaria", value: "Urticaria" },
    { label: "Vasculitis", value: "Vasculitis" },
    { label: "Wheeze", value: "Wheeze" },
    { label: "Unknown", value: "Unknown" },
    { label: "Angioedema", value: "Angioedema" },
    { label: "Bullous Eruption", value: "Bullous Eruption" },
    { label: "Dermatitis Exfoliative", value: "Dermatitis Exfoliative" },
    { label: "Diarrhea (Severe)", value: "Diarrhea (Severe)" },
    { label: "Dyspnoea", value: "Dyspnoea" },
  ],
  ALLERGY_REACTION_OUTCOME: [
    { label: "Life threatening", value: "Life threatening" },
    { label: "Congenital anomaly", value: "Congenital anomaly" },
    { label: "Required in-patient hospitalisation", value: "Required in-patient hospitalisation" },
    {
      label: "Prolonged in-patient hospitalisation",
      value: "Prolonged in-patient hospitalisation",
    },
    {
      label: "Involved or significant disability/incapacity",
      value: "Involved or significant disability/incapacity",
    },
    { label: "Medically significant", value: "Medically significant" },
  ],
  ALLERGY_DRUG_PROBABILITY: [
    { label: "Definite", value: "Definite" },
    { label: "Unconfirmed", value: "Unconfirmed" },
    { label: "Probable", value: "Probable" },
    { label: "Possible", value: "Possible" },
    { label: "Unlikely", value: "Unlikely" },
  ],
});
